import { filter } from 'underscore';
import {
  i18nEnglish,
  i18nGerman,
  i18nFrench,
  i18nSpanish,
  i18nItalian,
  i18nPortuguese,
  i18nChinese,
} from '@bingads-webui-campaign-legacy/adextension-shared/model/multi-lang-i18n';

const headers = [
  ['English', [
    ['Age groups', i18nEnglish.get('StructuredSnippet_Example_Age_groups'), true],
    ['Amenities', i18nEnglish.get('StructuredSnippet_Example_Amenities')],
    ['Best sellers', i18nEnglish.get('StructuredSnippet_Example_Best_Sellers'), true],
    ['Brands', i18nEnglish.get('StructuredSnippet_Example_Brands')],
    ['Classes', i18nEnglish.get('StructuredSnippet_Example_Classes'), true],
    ['Courses', i18nEnglish.get('StructuredSnippet_Example_Courses')],
    ['Daily rates', i18nEnglish.get('StructuredSnippet_Example_Daily_rates'), true],
    ['Deals', i18nEnglish.get('StructuredSnippet_Example_Deals'), true],
    ['Degree programs', i18nEnglish.get('StructuredSnippet_Example_Degree_programs')],
    ['Departments', i18nEnglish.get('StructuredSnippet_Example_Departments'), true],
    ['Destinations', i18nEnglish.get('StructuredSnippet_Example_Destinations')],
    ['Featured hotels', i18nEnglish.get('StructuredSnippet_Example_Featured_hotels')],
    ['Flowers', i18nEnglish.get('StructuredSnippet_Example_Flowers'), true],
    ['Goods', i18nEnglish.get('StructuredSnippet_Example_Goods')],
    ['Grades', i18nEnglish.get('StructuredSnippet_Example_Grades'), true],
    ['Highlights', i18nEnglish.get('StructuredSnippet_Example_Highlights'), true],
    ['Insurance coverage', i18nEnglish.get('StructuredSnippet_Example_Insurance_coverage')],
    ['Items', i18nEnglish.get('StructuredSnippet_Example_Items')],
    ['Languages', i18nEnglish.get('StructuredSnippet_Example_Languages'), true],
    ['Locations', i18nEnglish.get('StructuredSnippet_Example_Locations'), true],
    ['Models', i18nEnglish.get('StructuredSnippet_Example_Models')],
    ['Neighborhoods', i18nEnglish.get('StructuredSnippet_Example_Neighborhoods')],
    ['Occasions', i18nEnglish.get('StructuredSnippet_Example_Occasions'), true],
    ['Prices', i18nEnglish.get('StructuredSnippet_Example_Prices'), true],
    ['Rates', i18nEnglish.get('StructuredSnippet_Example_Rates'), true],
    ['Ratings', i18nEnglish.get('StructuredSnippet_Example_Ratings'), true],
    ['School districts', i18nEnglish.get('StructuredSnippet_Example_School_districts'), true],
    ['Services', i18nEnglish.get('StructuredSnippet_Example_Services')],
    ['Service catalog', i18nEnglish.get('StructuredSnippet_Example_Service_catalog')],
    ['Shows', i18nEnglish.get('StructuredSnippet_Example_Shows')],
    ['Sizes', i18nEnglish.get('StructuredSnippet_Example_Sizes'), true],
    ['Styles', i18nEnglish.get('StructuredSnippet_Example_Styles')],
    ['Tools', i18nEnglish.get('StructuredSnippet_Example_Tools'), true],
    ['Topics', i18nEnglish.get('StructuredSnippet_Example_Topics'), true],
    ['Types', i18nEnglish.get('StructuredSnippet_Example_Types')],
    ['Vacations', i18nEnglish.get('StructuredSnippet_Example_Vacations'), true],
    ['Vehicles', i18nEnglish.get('StructuredSnippet_Example_Vehicles'), true],
    ['What', i18nEnglish.get('StructuredSnippet_Example_What'), true],
    ['Who', i18nEnglish.get('StructuredSnippet_Example_Who'), true],
    ['Why', i18nEnglish.get('StructuredSnippet_Example_Why'), true],
  ]],
  ['German', [
    ['Abteilungen', i18nGerman.get('StructuredSnippet_Example_Departments'), true],
    ['Altersgruppen', i18nGerman.get('StructuredSnippet_Example_Age_groups'), true],
    ['Angebote', i18nGerman.get('StructuredSnippet_Example_Deals'), true],
    ['Anlässe', i18nGerman.get('StructuredSnippet_Example_Occasions'), true],
    ['Artikel', i18nGerman.get('StructuredSnippet_Example_Items')],
    ['Ausstattung', i18nGerman.get('StructuredSnippet_Example_Amenities')],
    ['Bestseller', i18nGerman.get('StructuredSnippet_Example_Best_Sellers'), true],
    ['Bewertungen', i18nGerman.get('StructuredSnippet_Example_Ratings'), true],
    ['Blumen', i18nGerman.get('StructuredSnippet_Example_Flowers'), true],
    ['Dienstkatalog', i18nGerman.get('StructuredSnippet_Example_Service_catalog')],
    ['Dienstleistungen', i18nGerman.get('StructuredSnippet_Example_Services')],
    ['Fahrzeuge', i18nGerman.get('StructuredSnippet_Example_Vehicles'), true],
    ['Ferien', i18nGerman.get('StructuredSnippet_Example_Vacations'), true],
    ['Größen', i18nGerman.get('StructuredSnippet_Example_Sizes'), true],
    ['Highlights', i18nGerman.get('StructuredSnippet_Example_Highlights'), true],
    ['Klassen', i18nGerman.get('StructuredSnippet_Example_Classes'), true],
    ['Kurse', i18nGerman.get('StructuredSnippet_Example_Courses')],
    ['Marken', i18nGerman.get('StructuredSnippet_Example_Brands')],
    ['Modelle', i18nGerman.get('StructuredSnippet_Example_Models')],
    ['Noten', i18nGerman.get('StructuredSnippet_Example_Grades'), true],
    ['Orte', i18nGerman.get('StructuredSnippet_Example_Locations'), true],
    ['Preise', i18nGerman.get('StructuredSnippet_Example_Prices'), true],
    ['Schulbezirke', i18nGerman.get('StructuredSnippet_Example_School_districts'), true],
    ['Serien', i18nGerman.get('StructuredSnippet_Example_Shows')],
    ['Sprachen', i18nGerman.get('StructuredSnippet_Example_Languages'), true],
    ['Stile', i18nGerman.get('StructuredSnippet_Example_Styles')],
    ['Studiengänge', i18nGerman.get('StructuredSnippet_Example_Degree_programs')],
    ['Tagespreise', i18nGerman.get('StructuredSnippet_Example_Daily_rates'), true],
    ['Tarife', i18nGerman.get('StructuredSnippet_Example_Rates'), true],
    ['Themen', i18nGerman.get('StructuredSnippet_Example_Topics'), true],
    ['Typen', i18nGerman.get('StructuredSnippet_Example_Types')],
    ['Versicherungsleistung', i18nGerman.get('StructuredSnippet_Example_Insurance_coverage')],
    ['Viertel', i18nGerman.get('StructuredSnippet_Example_Neighborhoods')],
    ['Vorgestellte Hotels', i18nGerman.get('StructuredSnippet_Example_Featured_hotels')],
    ['Waren', i18nGerman.get('StructuredSnippet_Example_Goods')],
    ['Warum', i18nGerman.get('StructuredSnippet_Example_Why'), true],
    ['Was', i18nGerman.get('StructuredSnippet_Example_What'), true],
    ['Wer', i18nGerman.get('StructuredSnippet_Example_Who'), true],
    ['Werkzeuge', i18nGerman.get('StructuredSnippet_Example_Tools'), true],
    ['Ziele', i18nGerman.get('StructuredSnippet_Example_Destinations')],
  ]],
  ['French', [
    ['Âge', i18nFrench.get('StructuredSnippet_Example_Age_groups'), true],
    ['Biens', i18nFrench.get('StructuredSnippet_Example_Goods')],
    ['Catalogue de services', i18nFrench.get('StructuredSnippet_Example_Service_catalog')],
    ['Catégories', i18nFrench.get('StructuredSnippet_Example_Grades'), true],
    ['Classes', i18nFrench.get('StructuredSnippet_Example_Classes'), true],
    ['Congés', i18nFrench.get('StructuredSnippet_Example_Vacations'), true],
    ['Cours', i18nFrench.get('StructuredSnippet_Example_Courses')],
    ['Couverture d\'assurance', i18nFrench.get('StructuredSnippet_Example_Insurance_coverage')],
    ['Départements', i18nFrench.get('StructuredSnippet_Example_Departments'), true],
    ['Destinations', i18nFrench.get('StructuredSnippet_Example_Destinations')],
    ['Districts scolaires', i18nFrench.get('StructuredSnippet_Example_School_districts'), true],
    ['Éléments', i18nFrench.get('StructuredSnippet_Example_Items')],
    ['Émissions', i18nFrench.get('StructuredSnippet_Example_Shows')],
    ['Équipements', i18nFrench.get('StructuredSnippet_Example_Amenities')],
    ['Événements', i18nFrench.get('StructuredSnippet_Example_Occasions'), true],
    ['Fleurs', i18nFrench.get('StructuredSnippet_Example_Flowers'), true],
    ['Langues', i18nFrench.get('StructuredSnippet_Example_Languages'), true],
    ['Lieux', i18nFrench.get('StructuredSnippet_Example_Locations'), true],
    ['Marques', i18nFrench.get('StructuredSnippet_Example_Brands')],
    ['Meilleurs vendeurs', i18nFrench.get('StructuredSnippet_Example_Best_Sellers'), true],
    ['Modèles', i18nFrench.get('StructuredSnippet_Example_Models')],
    ['Notations', i18nFrench.get('StructuredSnippet_Example_Ratings'), true],
    ['Offres', i18nFrench.get('StructuredSnippet_Example_Deals'), true],
    ['Outils', i18nFrench.get('StructuredSnippet_Example_Tools'), true],
    ['Points forts', i18nFrench.get('StructuredSnippet_Example_Highlights'), true],
    ['Pourquoi', i18nFrench.get('StructuredSnippet_Example_Why'), true],
    ['Prix', i18nFrench.get('StructuredSnippet_Example_Prices'), true],
    ['Programmes d\'études', i18nFrench.get('StructuredSnippet_Example_Degree_programs')],
    ['Quartiers', i18nFrench.get('StructuredSnippet_Example_Neighborhoods')],
    ['Qui', i18nFrench.get('StructuredSnippet_Example_Who'), true],
    ['Quoi', i18nFrench.get('StructuredSnippet_Example_What'), true],
    ['Sélection d\'hôtels', i18nFrench.get('StructuredSnippet_Example_Featured_hotels')],
    ['Services', i18nFrench.get('StructuredSnippet_Example_Services')],
    ['Styles', i18nFrench.get('StructuredSnippet_Example_Styles')],
    ['Sujets', i18nFrench.get('StructuredSnippet_Example_Topics'), true],
    ['Tailles', i18nFrench.get('StructuredSnippet_Example_Sizes'), true],
    ['Tarifs', i18nFrench.get('StructuredSnippet_Example_Rates'), true],
    ['Tarifs journaliers', i18nFrench.get('StructuredSnippet_Example_Daily_rates'), true],
    ['Types', i18nFrench.get('StructuredSnippet_Example_Types')],
    ['Véhicules', i18nFrench.get('StructuredSnippet_Example_Vehicles'), true],
  ]],
  ['Spanish', [
    ['Artículos', i18nSpanish.get('StructuredSnippet_Example_Goods')],
    ['Barrios', i18nSpanish.get('StructuredSnippet_Example_Neighborhoods')],
    ['Calificaciones', i18nSpanish.get('StructuredSnippet_Example_Ratings'), true],
    ['Carreras universitarias', i18nSpanish.get('StructuredSnippet_Example_Degree_programs')],
    ['Catálogo de servicios', i18nSpanish.get('StructuredSnippet_Example_Service_catalog')],
    ['Clases', i18nSpanish.get('StructuredSnippet_Example_Classes'), true],
    ['Clasificaciones', i18nSpanish.get('StructuredSnippet_Example_Grades'), true],
    ['Cobertura de seguro', i18nSpanish.get('StructuredSnippet_Example_Insurance_coverage')],
    ['Contenidos destacados', i18nSpanish.get('StructuredSnippet_Example_Highlights'), true],
    ['Cursos', i18nSpanish.get('StructuredSnippet_Example_Courses')],
    ['Departamentos', i18nSpanish.get('StructuredSnippet_Example_Departments'), true],
    ['Destinos', i18nSpanish.get('StructuredSnippet_Example_Destinations')],
    ['Distritos escolares', i18nSpanish.get('StructuredSnippet_Example_School_districts'), true],
    ['Elementos', i18nSpanish.get('StructuredSnippet_Example_Items')],
    ['Estilos', i18nSpanish.get('StructuredSnippet_Example_Styles')],
    ['Flores', i18nSpanish.get('StructuredSnippet_Example_Flowers'), true],
    ['Grupos de edad', i18nSpanish.get('StructuredSnippet_Example_Age_groups'), true],
    ['Herramientas', i18nSpanish.get('StructuredSnippet_Example_Tools'), true],
    ['Hoteles destacados', i18nSpanish.get('StructuredSnippet_Example_Featured_hotels')],
    ['Idiomas', i18nSpanish.get('StructuredSnippet_Example_Languages'), true],
    ['Marcas', i18nSpanish.get('StructuredSnippet_Example_Brands')],
    ['Mejores vendedores', i18nSpanish.get('StructuredSnippet_Example_Best_Sellers'), true],
    ['Modelos', i18nSpanish.get('StructuredSnippet_Example_Models')],
    ['Ocasiones', i18nSpanish.get('StructuredSnippet_Example_Occasions'), true],
    ['Ofertas', i18nSpanish.get('StructuredSnippet_Example_Deals'), true],
    ['Por qué', i18nSpanish.get('StructuredSnippet_Example_Why'), true],
    ['Precios', i18nSpanish.get('StructuredSnippet_Example_Prices'), true],
    ['Programas', i18nSpanish.get('StructuredSnippet_Example_Shows')],
    ['Qué', i18nSpanish.get('StructuredSnippet_Example_What'), true],
    ['Quién', i18nSpanish.get('StructuredSnippet_Example_Who'), true],
    ['Servicios', i18nSpanish.get('StructuredSnippet_Example_Services')],
    ['Servicios adicionales', i18nSpanish.get('StructuredSnippet_Example_Amenities')],
    ['Tallas', i18nSpanish.get('StructuredSnippet_Example_Sizes'), true],
    ['Tarifas', i18nSpanish.get('StructuredSnippet_Example_Rates'), true],
    ['Tarifas diarias', i18nSpanish.get('StructuredSnippet_Example_Daily_rates'), true],
    ['Temas', i18nSpanish.get('StructuredSnippet_Example_Topics'), true],
    ['Tipos', i18nSpanish.get('StructuredSnippet_Example_Types')],
    ['Ubicaciones', i18nSpanish.get('StructuredSnippet_Example_Locations'), true],
    ['Vacaciones', i18nSpanish.get('StructuredSnippet_Example_Vacations'), true],
    ['Vehículos', i18nSpanish.get('StructuredSnippet_Example_Vehicles'), true],
  ]],
  ['Italian', [
    ['Argomenti', i18nItalian.get('StructuredSnippet_Example_Topics'), true],
    ['Articoli', i18nItalian.get('StructuredSnippet_Example_Items')],
    ['Attrattive', i18nItalian.get('StructuredSnippet_Example_Amenities')],
    ['Beni', i18nItalian.get('StructuredSnippet_Example_Goods')],
    ['Catalogo de servizi', i18nItalian.get('StructuredSnippet_Example_Service_catalog')],
    ['Chi', i18nItalian.get('StructuredSnippet_Example_Who'), true],
    ['Copertura assicurativa', i18nItalian.get('StructuredSnippet_Example_Insurance_coverage')],
    ['Corsi', i18nItalian.get('StructuredSnippet_Example_Courses')],
    ['Corsi di studio', i18nItalian.get('StructuredSnippet_Example_Degree_programs')],
    ['Cosa', i18nItalian.get('StructuredSnippet_Example_What'), true],
    ['Destinazioni', i18nItalian.get('StructuredSnippet_Example_Destinations')],
    ['Dimensioni', i18nItalian.get('StructuredSnippet_Example_Sizes'), true],
    ['Distretti scolastici', i18nItalian.get('StructuredSnippet_Example_School_districts'), true],
    ['Fasce di età', i18nItalian.get('StructuredSnippet_Example_Age_groups'), true],
    ['Fiori', i18nItalian.get('StructuredSnippet_Example_Flowers'), true],
    ['Gradi', i18nItalian.get('StructuredSnippet_Example_Grades'), true],
    ['Hotel consigliati', i18nItalian.get('StructuredSnippet_Example_Featured_hotels')],
    ['In evidenza', i18nItalian.get('StructuredSnippet_Example_Highlights'), true],
    ['Lezioni', i18nItalian.get('StructuredSnippet_Example_Classes'), true],
    ['Lingue', i18nItalian.get('StructuredSnippet_Example_Languages'), true],
    ['Località', i18nItalian.get('StructuredSnippet_Example_Locations'), true],
    ['Marche', i18nItalian.get('StructuredSnippet_Example_Brands')],
    ['Modelli', i18nItalian.get('StructuredSnippet_Example_Models')],
    ['Occasioni', i18nItalian.get('StructuredSnippet_Example_Occasions'), true],
    ['Offerte', i18nItalian.get('StructuredSnippet_Example_Deals'), true],
    ['Perché', i18nItalian.get('StructuredSnippet_Example_Why'), true],
    ['Più venduti', i18nItalian.get('StructuredSnippet_Example_Best_Sellers'), true],
    ['Prezzi', i18nItalian.get('StructuredSnippet_Example_Prices'), true],
    ['Programmi', i18nItalian.get('StructuredSnippet_Example_Shows')],
    ['Quartieri', i18nItalian.get('StructuredSnippet_Example_Neighborhoods')],
    ['Reparti', i18nItalian.get('StructuredSnippet_Example_Departments'), true],
    ['Servizi', i18nItalian.get('StructuredSnippet_Example_Services')],
    ['Stili', i18nItalian.get('StructuredSnippet_Example_Styles')],
    ['Strumenti', i18nItalian.get('StructuredSnippet_Example_Tools'), true],
    ['Tariffe', i18nItalian.get('StructuredSnippet_Example_Rates'), true],
    ['Tariffe giornaliere', i18nItalian.get('StructuredSnippet_Example_Daily_rates'), true],
    ['Tipi', i18nItalian.get('StructuredSnippet_Example_Types')],
    ['Vacanze', i18nItalian.get('StructuredSnippet_Example_Vacations'), true],
    ['Valutazioni', i18nItalian.get('StructuredSnippet_Example_Ratings'), true],
    ['Veicoli', i18nItalian.get('StructuredSnippet_Example_Vehicles'), true],
  ]],
  ['Portuguese', [
    ['Bens', i18nPortuguese.get('StructuredSnippet_Example_Goods')],
    ['Catálogo de serviços', i18nPortuguese.get('StructuredSnippet_Example_Service_catalog')],
    ['Classes', i18nPortuguese.get('StructuredSnippet_Example_Classes'), true],
    ['Classificações', i18nPortuguese.get('StructuredSnippet_Example_Ratings'), true],
    ['Cobertura do seguro', i18nPortuguese.get('StructuredSnippet_Example_Insurance_coverage')],
    ['Comodidades', i18nPortuguese.get('StructuredSnippet_Example_Amenities')],
    ['Cursos', i18nPortuguese.get('StructuredSnippet_Example_Courses')],
    ['Departmentos', i18nPortuguese.get('StructuredSnippet_Example_Departments'), true],
    ['Destaques', i18nPortuguese.get('StructuredSnippet_Example_Highlights'), true],
    ['Destinos', i18nPortuguese.get('StructuredSnippet_Example_Destinations')],
    ['Distritos escolares', i18nPortuguese.get('StructuredSnippet_Example_School_districts'), true],
    ['Estilos', i18nPortuguese.get('StructuredSnippet_Example_Styles')],
    ['Faixas etárias', i18nPortuguese.get('StructuredSnippet_Example_Age_groups'), true],
    ['Férias', i18nPortuguese.get('StructuredSnippet_Example_Vacations'), true],
    ['Ferramentas', i18nPortuguese.get('StructuredSnippet_Example_Tools'), true],
    ['Flores', i18nPortuguese.get('StructuredSnippet_Example_Flowers'), true],
    ['Hotéis em destaque', i18nPortuguese.get('StructuredSnippet_Example_Featured_hotels')],
    ['Idiomas', i18nPortuguese.get('StructuredSnippet_Example_Languages'), true],
    ['Itens', i18nPortuguese.get('StructuredSnippet_Example_Items')],
    ['Locais', i18nPortuguese.get('StructuredSnippet_Example_Locations'), true],
    ['Marcas', i18nPortuguese.get('StructuredSnippet_Example_Brands')],
    ['Melhores vendedores', i18nPortuguese.get('StructuredSnippet_Example_Best_Sellers'), true],
    ['Modelos', i18nPortuguese.get('StructuredSnippet_Example_Models')],
    ['Notas', i18nPortuguese.get('StructuredSnippet_Example_Grades'), true],
    ['O quê', i18nPortuguese.get('StructuredSnippet_Example_What'), true],
    ['Ocasiões', i18nPortuguese.get('StructuredSnippet_Example_Occasions'), true],
    ['Ofertas', i18nPortuguese.get('StructuredSnippet_Example_Deals'), true],
    ['Por quê', i18nPortuguese.get('StructuredSnippet_Example_Why'), true],
    ['Preços', i18nPortuguese.get('StructuredSnippet_Example_Prices'), true],
    ['Programas', i18nPortuguese.get('StructuredSnippet_Example_Shows')],
    ['Programas de graduação', i18nPortuguese.get('StructuredSnippet_Example_Degree_programs')],
    ['Quem', i18nPortuguese.get('StructuredSnippet_Example_Who'), true],
    ['Serviços', i18nPortuguese.get('StructuredSnippet_Example_Services')],
    ['Tamanhos', i18nPortuguese.get('StructuredSnippet_Example_Sizes'), true],
    ['Taxas', i18nPortuguese.get('StructuredSnippet_Example_Rates'), true],
    ['Taxas diárias', i18nPortuguese.get('StructuredSnippet_Example_Daily_rates'), true],
    ['Tipos', i18nPortuguese.get('StructuredSnippet_Example_Types')],
    ['Tópicos', i18nPortuguese.get('StructuredSnippet_Example_Topics'), true],
    ['Veículos', i18nPortuguese.get('StructuredSnippet_Example_Vehicles'), true],
    ['Vizinhança', i18nPortuguese.get('StructuredSnippet_Example_Neighborhoods')],
  ]],
  ['Dutch', [
    ['Aanbevolen hotels', 'Hotel Meerzicht, Luxury Inn'],
    ['Aanbiedingen', 'Opruimingsartikelen, twee kopen één gratis, studentenkortingen', true],
    ['Afdelingen', 'Huishoudapparatuur, garage, thuisbioscoop', true],
    ['Beoordelingen', 'Best verkocht, goedkoopst, meest beoordeeld', true],
    ['Best verkocht', 'Deal van de dag, Verjaardagsboeket, Tuinboeket', true],
    ['Bestemmingen', 'Las Vegas, New York, Tokio, Rome, Cancún, Parijs'],
    ['Bloemen', 'Rozen, Madeliefjes, Lelies', true],
    ['Buurten', 'Jordaan, Staatsliedenbuurt, centrum'],
    ['Cursussen', 'lineaire algebra, creatief schrijven, datastructuren'],
    ['Dagtarieven', 'Alleenstaanden, koppels, groepen', true],
    ['Dekking', 'aansprakelijkheid, aanrijding, uitgebreid'],
    ['Gelegenheden', 'Diploma-uitreikingen, Beterschap, Nieuwe baby', true],
    ['Gereedschap', 'Elektrisch, pneumatisch, hydraulisch', true],
    ['Grootten', 'Small, Medium, Large', true],
    ['Hoogtepunten', 'Wat te eten, wat te zien, wat te doen', true],
    ['Items', 'Laptops, tv’s, gameconsoles'],
    ['Klassen', 'Diamond, Premium, Premium Plus', true],
    ['Leeftijdsgroep', '40 en jonger, 41 tot 50, 51 tot 60', true],
    ['Lessen', 'Defensief rijden, huiseigendom 101', true],
    ['Locaties', 'Noord-Amerika, Europa, Azië', true],
    ['Merken', 'Windows, Xbox, Skype'],
    ['Modellen', 'Corolla, Prius, Yaris'],
    ['Onderwerpen', 'Inkomen, pensioen, belastingen', true],
    ['Prijzen', 'Minder dan $10, $50-$100, meer dan $1000', true],
    ['Producten', 'Kleding, boeken, bordspellen'],
    ['Schooldistricten', 'Verkennen, rangschikkingen, suggesties', true],
    ['Servicecatalogus', 'olie verversen, smogcontrole, bandenuitlijning'],
    ['Services', 'Mannenkapsel, vrouwenkapsel, kinderkapsel'],
    ['Shows', 'De Reis, Ridders, American Dancer'],
    ['Stijlen', 'gecapitonneerd, avondjurken, galajurken, strandjurken'],
    ['Studieprogramma\'s', 'boekhouden, biologie, psychologie'],
    ['Talen', 'Engels, Spaans, Chinees', true],
    ['Tarieven', 'Dagelijks, maandelijks, jaarlijks', true],
    ['Typen', 'hanglampen, plafondlampen, muurlampen'],
    ['Vakanties', 'Eilanden, roadtrips, cruises', true],
    ['Voertuigen', 'Compact, SUV, cabrio', true],
    ['Voorzieningen', 'ski-opslag, zwembad, restaurant'],
    ['Waarom', 'Verjaardag, afstuderen, speciale datum', true],
    ['Wat', 'Bloemen, snoepgoed, cadeaukaarten', true],
    ['Wie', 'Voor hem, voor haar, voor koppels', true],
  ]],
  ['Swedish', [
    ['Ämnen', 'Inkomst, pension, skatter', true],
    ['Avdelningar', 'Apparater, garage, hemmabio', true],
    ['Bekvämligheter', 'Skidförvaring, Simhall, Restaurang'],
    ['Betyg', 'Bästsäljare, billigaste, de som fått flest betyg', true],
    ['Bilmodeller', 'Fjällstuga, Hotell vid havet, Rum och frukost'],
    ['Blommor', 'Rosor, prästkragar, liljor', true],
    ['Dagliga priser', 'Ensamstående, par, grupper', true],
    ['Erbjudanden', 'Lagerrensning, Köp en få en, Studentrabatter', true],
    ['Evenemang', 'Examen, Bli frisk, Ny bebis', true],
    ['Fordon', 'Kompakt, SUV, cabriolet', true],
    ['Försäkringstyper', 'Ansvarsförsäkring, Vagnskadeförsäkring, Heltäckande försäkring'],
    ['Grannskap', 'Centrum, Östermalm, Södermalm, Kungsholmen'],
    ['Höjdpunkter', 'Vad kan man äta, vad kan man se, vad kan man göra', true],
    ['Hotellval', 'Scandic, Best Western, Radisson'],
    ['Klasser', 'Diamant, Premium, Premium Plus', true],
    ['Kurser', 'Linjär algebra, Kreativt skrivande, Datastruktur'],
    ['Lektioner', 'Defensiv körning, husägare 101', true],
    ['Objekt', 'Bärbara datorer, tv:ar, spelkonsoler'],
    ['Platser', 'Nordamerika, Europa, Asien', true],
    ['Priser', 'Under $10 USD, $50–$100 USD, över $1 000 USD', true],
    ['Program', 'Resan ut, Tornerspel, Tjosan – en fars'],
    ['Resmål', 'Las Vegas, New York, Tokyo, Rom, Cancun, Paris'],
    ['Semestrar', 'Öar, långresor med bil, kryssningar', true],
    ['Servicekatalog', 'Byte av olja, Utsläppskontroll, Balansering av däck'],
    ['Skoldistrikt', 'Utforska, rangordningar, förslag', true],
    ['Språk', 'Engelska, spanska, kinesiska', true],
    ['Stilar', 'Öronlapp, Chesterfield, Stressless, Rokoko, Skinn, Läs'],
    ['Storlekar', 'Small, Medium, Large', true],
    ['Storsäljare', 'Dagens affär, Födelsedagsbukett, Trädgårdsbukett', true],
    ['Taxor', 'Daglig, månadsvis, årlig', true],
    ['Tjänster', 'Herrklippning, damklippning, barnklippning'],
    ['Typer', 'Fondlampor, Taklampor, Vägglampor'],
    ['Utbildningar', 'Redovisning, Biologi, Psykologi'],
    ['Vad', 'Blommor, godis, presentkort', true],
    ['Varför', 'Födelsedagar, examina, jubileum', true],
    ['Varor', 'Kläder, böcker, brädspel'],
    ['Varumärken', 'Windows, Xbox, Skype'],
    ['Vem', 'För honom, för henne, för par', true],
    ['Verktyg', 'Elektrisk, Tryckluftsdriven, Hydraulisk', true],
    ['Åldersgrupp', '40 och under, 41 till 50, 51 till 60', true],
  ]],
  ['TraditionalChinese', [
    ['主題', i18nChinese.get('StructuredSnippet_Example_Topics'), true],
    ['交通工具', i18nChinese.get('StructuredSnippet_Example_Vehicles'), true],
    ['什麼', i18nChinese.get('StructuredSnippet_Example_What'), true],
    ['位置', i18nChinese.get('StructuredSnippet_Example_Locations'), true],
    ['價錢', i18nChinese.get('StructuredSnippet_Example_Prices'), true],
    ['優惠', i18nChinese.get('StructuredSnippet_Example_Deals'), true],
    ['品牌', i18nChinese.get('StructuredSnippet_Example_Brands')],
    ['商品', i18nChinese.get('StructuredSnippet_Example_Goods')],
    ['型號', i18nChinese.get('StructuredSnippet_Example_Models')],
    ['大小', i18nChinese.get('StructuredSnippet_Example_Sizes'), true],
    ['學位課程', i18nChinese.get('StructuredSnippet_Example_Degree_programs')],
    ['學區', i18nChinese.get('StructuredSnippet_Example_School_districts'), true],
    ['工具', i18nChinese.get('StructuredSnippet_Example_Tools'), true],
    ['度假', i18nChinese.get('StructuredSnippet_Example_Vacations'), true],
    ['承保範圍', i18nChinese.get('StructuredSnippet_Example_Insurance_coverage')],
    ['服務', i18nChinese.get('StructuredSnippet_Example_Services')],
    ['服務目錄', i18nChinese.get('StructuredSnippet_Example_Service_catalog')],
    ['款式', i18nChinese.get('StructuredSnippet_Example_Styles')],
    ['每日費率', i18nChinese.get('StructuredSnippet_Example_Daily_rates'), true],
    ['為什麼', i18nChinese.get('StructuredSnippet_Example_Why'), true],
    ['目的地', i18nChinese.get('StructuredSnippet_Example_Destinations')],
    ['社區', i18nChinese.get('StructuredSnippet_Example_Neighborhoods')],
    ['等級', i18nChinese.get('StructuredSnippet_Example_Grades'), true],
    ['節目', i18nChinese.get('StructuredSnippet_Example_Shows')],
    ['精選飯店', i18nChinese.get('StructuredSnippet_Example_Featured_hotels')],
    ['設施', i18nChinese.get('StructuredSnippet_Example_Amenities')],
    ['評分', i18nChinese.get('StructuredSnippet_Example_Ratings'), true],
    ['語言', i18nChinese.get('StructuredSnippet_Example_Languages'), true],
    ['誰', i18nChinese.get('StructuredSnippet_Example_Who'), true],
    ['課程', i18nChinese.get('StructuredSnippet_Example_Courses')],
    ['費率', i18nChinese.get('StructuredSnippet_Example_Rates'), true],
    ['部門', i18nChinese.get('StructuredSnippet_Example_Departments'), true],
    ['重點項目', i18nChinese.get('StructuredSnippet_Example_Highlights'), true],
    ['項目', i18nChinese.get('StructuredSnippet_Example_Items')],
    ['類別', i18nChinese.get('StructuredSnippet_Example_Classes'), true],
    ['類型', i18nChinese.get('StructuredSnippet_Example_Types')],
    ['暢銷品', i18nChinese.get('StructuredSnippet_Example_Best_Sellers'), true],
    ['年齡群組', i18nChinese.get('StructuredSnippet_Example_Age_groups'), true],
    ['花', i18nChinese.get('StructuredSnippet_Example_Flowers'), true],
    ['特殊節日', i18nChinese.get('StructuredSnippet_Example_Occasions'), true],
  ]],
  ['Danish', [
    ['Afdelinger', 'Apparater, garage, hjemmebiograf', true],
    ['Aldersgruppe', '40 og derunder, 41-50, 51 til 60', true],
    ['Bedst sælgende', 'Dagens tilbud, Fødselsdagsbuket, Havebuket', true],
    ['Bedømmelser', 'Diamond, Premium, Premium Plus', true],
    ['Begivenheder', 'Dimissioner, Bliv rask, Ny baby', true],
    ['Blomster', 'Roser, tusindfryd, liljer', true],
    ['Daglige priser', 'Singler, par, grupper', true],
    ['Design', 'Højhælede, Cowboy, Knælange, Ankel'],
    ['Destinationer', 'Paris, Berlin, London'],
    ['Elementer', 'Bærbare computere, fjernsyn, spilkonsoller'],
    ['Emner', 'Indtægt, pension, skat', true],
    ['Faciliteter', 'WiFi, Pool, Fitnesscenter, Tekøkken'],
    ['Ferier', 'Øer, bilferier, krydstogter', true],
    ['Forsikringsdækning', 'ansvar, kasko, glas, billeje'],
    ['Højdepunkter', 'Restauranter, seværdigheder, aktiviteter', true],
    ['Hvad', 'Blomster, slik, gavekort', true],
    ['Hvem', 'Til ham, til hende, til par', true],
    ['Hvorfor', 'Fødselsdag, eksamen, årsdag', true],
    ['Kandidatprogrammer', 'Virksomhedsadministration, Regnskab, HR management'],
    ['Klasser', 'Defensiv kørsel, status som boligejer for nybegyndere', true],
    ['Køretøjer', 'Mellemstor bil, firhjulstrækker, cabriolet', true],
    ['Kurser', 'Creative writing, Datastrukturer, Lineær algebra'],
    ['Kvarterer', 'Indre by, Frederiksberg, Vesterbro'],
    ['Lokaliteter', 'Nordamerika, Europa, Asien', true],
    ['Mærker', 'Windows, Xbox, Skype'],
    ['Modeller', 'Corolla, Prius, Yaris'],
    ['Priser', 'Under 10 USD, 50-100 USD, over 1000 USD', true],
    ['Satser', 'Dagligt, månedligt, årligt', true],
    ['Servicekatalog', 'Olieskift, Smogtjek, Hjuljustering'],
    ['Serviceydelser', 'Herrefrisør, Damefrisør, Børnefrisør'],
    ['Shows', 'Mama Mia, Matador, Gasolin'],
    ['Skoledistrikter', 'Udforsk, vurderinger, forslag', true],
    ['Sprog', 'Engelsk, spansk, kinesisk', true],
    ['Størrelser', 'Lille, medium, stor', true],
    ['Tilbud', 'Oprydningsvarer, køb en, og få en, rabatter til studerende', true],
    ['Typer', 'T-Shirts, Krus, Tasker, Kuglepenne'],
    ['Udvalgte hoteller', 'Skt. Petri, Nimb, Stella Maris'],
    ['Værktøjer', 'Elektrisk, pneumatisk, hydraulisk', true],
    ['Varer', 'Tøj, Bøger, Brætspil'],
    ['Vurderinger', 'Mest populære, billigste, flest anmeldelser', true],
  ]],
  ['Finnish', [
    ['Aiheet', 'Tulot, eläke, verot', true],
    ['Ajoneuvot', 'Compact, katumaasturi, avoauto', true],
    ['Arvosanat', 'Diamond, Premium, Premium Plus', true],
    ['Esitellyt hotellit', 'Omena-hotelli, Arthur, Helka'],
    ['Esitykset', 'Sinkkuelämää, Medusan isku, Räjähdyspisteessär'],
    ['Hinnat', 'Päivittäinen, kuukausittainen, vuosittainen', true],
    ['Hintataso', 'Alle 10 $, 50 $ – 100 $, yli 1 000 $', true],
    ['Huoltoluettelo', 'Öljynvaihto'],
    ['Ikäryhmä', '40 ja alle, 41-50, 51–60', true],
    ['Juhlapäivät', 'Valmistujaiset, nouse hyvin, Uusi vauva', true],
    ['Kaupunginosat', 'Aleksanterinkatu'],
    ['Kielet', 'Englanti, espanja, kiina', true],
    ['Kohokohdat', 'Syötävää, nähtävää, tehtävää', true],
    ['Koot', 'Pieni, keskikokoinen, suuri', true],
    ['Koulupiirit', 'Selaa, sijoitukset, ehdotukset', true],
    ['Kuka', 'Miehelle, naiselle, pariskunnille', true],
    ['Kukkia', 'Ruusut, Koiranputket, liljat', true],
    ['Kurssit', 'Luova kirjoittaminen, Tietorakenteet, Lineaarinen algebra'],
    ['Lomat', 'Saaret, automatkat, risteilyt', true],
    ['Luokat', 'Turvallinen ajaminen, kodinomistajan perusteet', true],
    ['Luokitukset', 'Myydyimmät, halvimmat, arvioiduimmat', true],
    ['Määränpäät', 'Pariisi, Berliini, Lontoo'],
    ['Mallit', 'Corolla, Prius, Yaris'],
    ['Miksi', 'Syntymäpäivä, valmistuminen, vuosipäivä', true],
    ['Mitä', 'Kukat, makeiset, lahjakortit', true],
    ['Mukavuudet', 'W-iFi, Uima-allas, Pienoiskeittiö'],
    ['Nimikkeet', 'Kannettavat, TV:t, Pelikonsolit'],
    ['Osastot', 'Kodinkoneet, korjaamo, kotiteatteri', true],
    ['Päivähinnat', 'Sinkut, pariskunnat, ryhmät', true],
    ['Palvelut', 'Miesten hiustenleikkuu, Naisten hiustenleikkuu, Lasten hiustenleikkuu'],
    ['Parhaat myyjät', 'Päivän tarjous, syntymäpäiväkimppu, puutarhakimppu', true],
    ['Sijainnit', 'Pohjois-Amerikka, Eurooppa, Aasia', true],
    ['Tarjoukset', 'Poistotuotteet, kaksi yhden hinnalla, opiskelija-alennukset', true],
    ['Tavarat', 'Vaatetus, Kirjat, Lautapelit'],
    ['Tuotemerkit', 'Windows, Xbox, Skype'],
    ['Tutkinto-ohjelmat', 'Liikkeenjohto, Kirjanpito, Henkilöstöhallinto'],
    ['Työkalut', 'Sähköinen, pneumaattinen, hydraulinen', true],
    ['Tyylit', 'Mokkasiinit, Bootsit, Maihinnousukengät, Chelsea-bootsit'],
    ['Tyypit', 'T-paidat, Mukit, Laukut, Kynät'],
    ['Vakuutuksen kattavuus', 'Kolmannen osapuolen vastuu, Kolari, Sateenvarjo, Autovuokraamot'],
  ]],
  ['Norwegian', [
    ['Aldersgruppe', '40 and under, 41 to 50, 51 to 60', true],
    ['Anledninger', 'Graduations, Get well, New baby', true],
    ['Avdelinger', 'Apparater, verksted, hjemmekino', true],
    ['Bestselgere', 'Deal of the day, Birthday bouquet, Garden bouquet', true],
    ['Blomster', 'Roses, Daisies, Lilies', true],
    ['Destinasjoner', 'Paris, Berlin, London'],
    ['Emner', 'Inntekt, pensjon, skatt', true],
    ['Fasiliteter', 'WiFi, Basseng, Treningssenter, Kjøkkenkrok'],
    ['Ferier', 'Øyer, bilturer, cruisereiser', true],
    ['Forsikring', 'Ansvarsforsikring, Kasko, Reiseforsikring, Bilutleie'],
    ['Fremhevede hoteller', 'Radisson, Thon, Scandic'],
    ['Gjenstander', 'Bærbare datamaskiner, TV-er, spillkonsoller'],
    ['Høydepunkter', 'Ting å spise, ting å se, ting å gjøre', true],
    ['Hva', 'Blomster, søtsaker, gavekort', true],
    ['Hvem', 'For ham, for henne, for par', true],
    ['Hvorfor', 'Bursdag, skoleavslutning, jubileum', true],
    ['Karakterer', 'Diamant, Premium, Premium Pluss', true],
    ['Kjøretøyer', 'Kompaktbil, SUV, kabriolet', true],
    ['Klasser', 'Defensiv kjøring, ny huseier', true],
    ['Kurs', 'Kreativ skriving, datastrukturer, lineær algebra'],
    ['Lokasjoner', 'Nord-Amerika, Europa, Asia', true],
    ['Merkevarer', 'Windows, Xbox, Skype'],
    ['Modeller', 'Corolla, Prius, Yaris'],
    ['Nabolag', 'Grünerløkka, Majorstuen, Tøyen'],
    ['Priser', 'Under $10, $50–$100, over $1000', true],
    ['Priser per dag', 'Single, par, grupper', true],
    ['Rangeringer', 'Bestselgere, billigst, flest anbefalinger', true],
    ['Satser', 'Daglig, månedlig, årlig', true],
    ['Servicekatalog', 'Oljebytte, Avgasskontroll, Dekkjustering'],
    ['Skoleområder', 'Utforsk, rangeringer, forslag', true],
    ['Språk', 'Engelsk, spansk, kinesisk', true],
    ['Stiler', 'Vintage, Streetstyle, Rock, Chic'],
    ['Størrelser', 'Liten, medium, stor', true],
    ['Tilbud', 'Salgsvarer, To for én, Studentrabatter', true],
    ['Tjenester', 'Langt hår, Kort hår, Barneklipp'],
    ['TV-serier', 'Farmen, Side om Side, SKAM'],
    ['Typer', 'T-skjorter, Kopper, Sekker, Penner'],
    ['Universitetsprogrammer', 'Bedriftsøkonomi, Regnskapsføring, HR'],
    ['Varer', 'Klær, bøker, brettspill'],
    ['Verktøyer', 'Elektrisk, pneumatisk, hydraulisk', true],
  ]],
  ['Polish', [
    ['Atrakcje', 'Co zjeść, Co zobaczyć, Co robić', true],
    ['Najlepsi sprzedawcy', 'Oferta dnia, Bukiet urodzinowy, Bukiet ogrodowy', true],
    ['Ceny', 'Poniżej 10 USD, 50–100 USSD, Powyżej 1000 USD', true],
    ['Co', 'Kwiaty, Słodycze, Karty podarunkowe', true],
    ['Dlaczego', 'Urodziny, Ukończenie szkoły, Rocznica', true],
    ['Działy', 'Urządzenia, Warsztat, Kino domowe', true],
    ['Grupa wiekowa', '40 lat i mniej, od 41 do 50 lat, od 51 do 60 lat', true],
    ['Języki', 'Angielski, Hiszpański, Chiński', true],
    ['Katalog usług', 'Wymiana oleju, Kontrola emisji spalin, Zbieżność kół'],
    ['Kategorie', 'Diamond, Premium, Premium Plus', true],
    ['Kierunki', 'Paryż, Berlin, Londyn'],
    ['Kto', 'Dla Niego, Dla Niej, Dla par', true],
    ['Kursy', 'Twórcze pisanie, Struktury danych, Algebra liniowa'],
    ['Kwiaty', 'róże, stokrotki, lilie', true],
    ['Lekcje', 'Jazda defensywna, Podstawowe informacje o mieszkaniu na własność', true],
    ['Lokalizacje', 'Ameryka Północna, Europa, Azja', true],
    ['Marki', 'Windows, Xbox, Skype'],
    ['Modele', 'Corolla, Prius, Yaris'],
    ['Narzędzia', 'Elektryczne, Pneumatyczne, Hydrauliczne', true],
    ['Obwody szkół', 'Przeglądaj, Rankingi, Sugestie', true],
    ['Oceny', 'Najczęściej kupowane, Najtańsze, Najczęściej oceniane', true],
    ['Okazje', 'Artykuły z wyprzedaży, 1 + 1 gratis, Zniżki studenckie', true],
    ['Okazje', 'Ukończenie szkoły, Wyzdrowiej, Nowe dziecko', true],
    ['Osiedla', 'Dzielnica finansowa, SOMA, North Beach'],
    ['Pojazdy', 'Kompakt, SUV, Kabriolet', true],
    ['Pokazy', 'The Voyage, Knights, American Dancer'],
    ['Polecane hotele', 'Luxury Inn, Alpine Lodge, Lakeside Hotel'],
    ['Pozycje', 'Laptopy, Telewizory, Konsole do gier'],
    ['Produkty', 'Odzież, Książki, Gra planszowa'],
    ['Rozmiary', 'Małe, Średnie, Duże', true],
    ['Stawki', 'Dziennie, Miesięcznie, Rocznie', true],
    ['Stawki dzienne', 'Single, Pary, Grupy', true],
    ['Studia', 'Zarządzanie, Księgowość, Zarządzanie kadrami'],
    ['Style', 'Chukka, Kowbojki, Glany, Sztyblety'],
    ['Tematy', 'Przychód, Emerytura, Podatki', true],
    ['Typy', 'T-shirty, Kubki, Torby, Długopisy'],
    ['Udogodnienia', 'Wi-Fi, Basen, Centrum fitness, Aneks kuchenny'],
    ['Usługi', 'Strzyżenie męskie, Strzyżenie damskie, Strzyżenie dziecięce'],
    ['Wakacje', 'Wyspy, Wycieczki objazdowe, Rejsy', true],
    ['Zakres ubezpieczenia', 'OC, AC, Polisy parasolowe, Wypożyczalnie samochodów'],
  ]],
  ['Turkish', [
    ['Aletler', 'Elektrik, Pnömatik, Hidrolik', true],
    ['Araçlar', 'Kompakt, SUV, Üstü açılabilir', true],
    ['Boyutlar', 'Küçük, Orta, Büyük', true],
    ['Çiçekler', 'Güller, Papatyalar, Zambaklar', true],
    ['Departmanlar', 'Elektrikli aletler, Garaj, Ev sineması', true],
    ['Derecelendirmeler', 'Çok satanlar, En ucuzlar, En çok değerlendirilenler', true],
    ['Diller', 'İngilizce, İspanyolca, Çince', true],
    ['Fırsatlar', 'Mezuniyetler, İyileşin, Yeni bebek', true],
    ['En Çok Satanlar', 'Günün fırsatı, Doğum günü buketi, Bahçe buketi', true],
    ['Fiyatlar', '10 ABD Dolarının altı, 50-100 ABD Doları arası, 1000 ABD Dolarının üstü', true],
    ['Fırsatlar', 'Sezon sonu ürünleri, Bir alana bir bedava, Öğrenci indirimleri', true],
    ['Gösteriler', 'The Voyage, Knights, American Dancer'],
    ['Günlük ücretler', 'Tek kişi, Çift, Grup', true],
    ['Hizmet kataloğu', 'Yağ değişimi, Emisyon kontrolü, Teker hizalaması'],
    ['Hizmetler', 'Erkek saç kesimi, Kadın saç kesimi, Çocuk saç kesimi'],
    ['Kim', 'Erkekler için, Kadınlar için, Çiftler için', true],
    ['Konu başlıkları', 'Gelir, Emeklilik, Vergiler', true],
    ['Konumlar', 'Kuzey Amerika, Avrupa, Asya', true],
    ['Kurslar', 'Yaratıcı yazarlık, Veri yapıları, Lineer cebir'],
    ['Lisans programları', 'İş yönetimi, Muhasebe, İK yönetimi'],
    ['Mahalleler', 'Finans bölgesi, SOMA, Kuzey Sahili'],
    ['Markalar', 'Windows, Xbox, Skype'],
    ['Modeller', 'Corolla, Prius, Yaris'],
    ['Ne', 'Çiçekler, Şekerler, Hediye kartları', true],
    ['Neden', 'Doğun günü, Mezuniyet, Yıl dönümü', true],
    ['Notlar', 'Diamond, Premium, Premium Plus', true],
    ['Öğeler', 'Dizüstü bilgisayarlar, Televizyonlar, Oyun konsolları'],
    ['Okul bölgeleri', 'Keşfet, Sıralamalar, Öneriler', true],
    ['Olanaklar', 'WiFi, Havuz, Fitness merkezi, Mutfak'],
    ['Öne çıkan oteller', 'Lüks Otel, Dağ Evi, Göl Kenarı Oteli'],
    ['Öne çıkanlar', 'Yenecek yemekler, görülecek yerler, yapılacak şeyler', true],
    ['Sigorta kapsamı', 'Üçüncü taraf sorumluluğu, Çarpışma, Şemsiye, Araba kiralama'],
    ['Sınıflar', 'İleri sürüş teknikleri, Ev sahipliğine giriş', true],
    ['Stiller', 'Chukka, Kovboy, Asker, Chelsea'],
    ['Tatiller', 'Adalar, Seyahatler, Yat gezileri', true],
    ['Türler', 'Tişörtler, Kupalar, Çantalar, Kalemler'],
    ['Ücretler', 'Günlük, Aylık, Yıllık', true],
    ['Ürünler', 'Kıyafet, Kitap, Kutu oyunu'],
    ['Varış noktaları', 'Paris, Berlin, London'],
    ['Yaş grupları', '40 yaş ve altı, 41 ila 50, 51 ila 60', true],
  ]],
  ['Greek', [
    ['Αγαθά', 'Ρούχα, Βιβλία, Επιτραπέζια παιχνίδια'],
    ['Αξιολογήσεις', 'Ευπώλητα, Φθηνότερα, Με τις περισσότερες κριτικές', true],
    ['Ασφαλιστική κάλυψη', 'Ευθύνη τρίτου μέρους, Σύγκρουση, Ευρεία κάλυψη, Ενοικίαση αυτοκινήτων'],
    ['Βαθμοί', 'Diamond, Premium, Premium Plus', true],
    ['Γειτονιές', 'Financial district, SOMA, North Beach'],
    ['Γιατί', 'Γενέθλια, Αποφοίτηση, Επέτειος', true],
    ['Γλώσσες', 'Αγγλικά, Ισπανικά, Κινεζικά', true],
    ['Διακοπές', 'Νησιά, Οδικά ταξίδια, Κρουαζιέρες', true],
    ['Εκπομπές', 'The Voyage, Knights, American Dancer'],
    ['Επιλεγμένα ξενοδοχεία', 'Luxury Inn, Alpine Lodge, Lakeside Hotel'],
    ['Επισημάνσεις', 'Φαγητό, Αξιοθέατα, Δραστηριότητες', true],
    ['Εργαλεία', 'Ηλεκτρικό, Πεπιεσμένου αέρα, Υδραυλικό', true],
    ['Ηλικιακές ομάδες', '40 και κάτω, 41 έως 50, 51 έως 60', true],
    ['Ημερήσιες τιμές', 'Εργένηδες, Ζευγάρια, Ομάδες', true],
    ['Θέματα', 'Εισόδημα, Συνταξιοδότηση, Φόροι', true],
    ['Κατάλογος υπηρεσιών', 'Αλλαγή λαδιών, Έλεγχος εκπομπών, Ευθυγράμμιση ελαστικών'],
    ['Λουλούδια', 'Τριαντάφυλλα, Μαργαρίτες, Κρίνα', true],
    ['Μαθήματα', 'Δημιουργική γραφή, Δομές δεδομένων, Γραμμική άλγεβρα'],
    ['Μάρκες', 'Windows, Xbox, Skype'],
    ['Μεγέθη', 'Μικρό, Μεσαίο, Μεγάλο', true],
    ['Μοντέλα', 'Corolla, Prius, Yaris'],
    ['Οχήματα', 'Μικρό πόλης, SUV, Ανοιχτό', true],
    ['Παροχές', 'WiFi, Πισίνα, Γυμναστήριο, Μικρή κουζίνα'],
    ['Περιστάσεις', 'Αποφοιτήσεις, Γίνετε καλά, Νέο μωρό', true],
    ['Ποιος', 'Για εκείνον, Για εκείνη, Για ζευγάρια', true],
    ['Προγράμματα πτυχίου', 'Διοίκηση επιχειρήσεων, Λογιστική, Διαχείριση ανθρώπινων πόρων'],
    ['Προορισμοί', 'Παρίσι, Βερολίνο, Λονδίνο'],
    ['Στοιχεία', 'Φορητοί υπολογιστές, Τηλεοράσεις, Κονσόλες παιχνιδιών'],
    ['Στυλ', 'Chukka, Cowboy, Combat, Chelsea'],
    ['Συμφωνίες', 'Εκπτωτικά είδη, Αγοράζετε ένα και παίρνετε ένα δωρεάν, Φοιτητικές εκπτώσεις', true],
    ['Σχολικές περιφέρειες', 'Εξερεύνηση, Βαθμολογία, Προτάσεις', true],
    ['Τάξεις', 'Αμυντική οδήγηση, Εισαγωγή στην ιδιοκατοίκηση', true],
    ['Τι', 'Λουλούδια, Γλυκά, Κάρτες δώρων', true],
    ['Τιμές', 'Κάτω από 10 $, 50-100 $, Πάνω από 1000 $', true],
    ['Τιμοκατάλογος', 'Καθημερινά, Μηνιαία, Ετήσια', true],
    ['Τμήματα', 'Οικιακές συσκευές, Γκαράζ, Οικιακός κινηματογράφος', true],
    ['Τοποθεσίες', 'Βόρεια Αμερική, Ευρώπη, Ασία', true],
    ['Τύποι', 'Μπλουζάκια, Κούπες, Τσάντες, Στυλό'],
    ['Υπηρεσίες', 'Ανδρικό κούρεμα, Γυναικείο κούρεμα, Παιδικό κούρεμα'],
    ['Best sellers', 'Προσφορά της ημέρας, Ανθοδέσμη γενεθλίων, ανθοδέσμη κήπου', true],
  ]],
  ['Bulgarian', [
    ['Акценти', 'Какво да хапнете, Какво да видите, Какво да направите', true],
    ['Бестселъри', 'Сделка за деня, букет за рожден ден, букет от градината', true],
    ['Ваканции', 'Острови, Пътувания, Круизи', true],
    ['Възрастови групи', '40 и по-малко, от 41 до 50, от 51 до 60', true],
    ['Дестинации', 'Париж, Берлин, Лондон'],
    ['Дипломни програми', 'Бизнес администрация, Счетоводство, Управление на човешки ресурси'],
    ['Дневни ставки', 'Необвързани, Двойки, Групи', true],
    ['Езици', 'Английски, Испански, Китайски', true],
    ['Елементи', 'Лаптопи, Телевизори, Конзоли за игри'],
    ['Застрахователно покритие', 'Отговорност на трети лица, Катастрофа, Частна застраховка, Коли под наем'],
    ['Защо', 'Рожден ден, Дипломиране, Годишнина', true],
    ['Инструменти', 'Електрически, Пневматични, Хидравлични', true],
    ['Какво', 'Цветя, Бонбони, Подаръчни картички', true],
    ['Каталог на услугите', 'Смяна на маслото, Проверка за вредни емисии, Реглаж на гумите'],
    ['Квартали', 'Финансови центрове, Финанси, Бизнес парк'],
    ['Класове', 'Отбранително шофиране, Първи стъпки в собствеността на домове', true],
    ['Кой', 'За него, За нея, За двойки', true],
    ['Курсове', 'Творческо писане, Структури на данни, Линейна алгебра'],
    ['Марки', 'Windows, Xbox, Skype'],
    ['Местоположения', 'Северна Америка, Европа, Азия', true],
    ['Модели', 'Corolla, Prius, Yaris'],
    ['Отдел', 'Уреди, Гараж, Домашно кино', true],
    ['Оферти', 'Продукти от разпродажба, Купете едно – вземете още едно, Студентски отстъпки', true],
    ['Оценки от критици', 'Диамантено, Премиум, Премиум плюс', true],
    ['Оценки', 'Най-добри продавачи, Най-евтини, Най-разглеждани', true],
    ['Превозни средства', 'Компактен, Джип, Кабриолет', true],
    ['Предавания', 'Последният печели, 120 минути, Моят плейлист'],
    ['Препоръчани хотели', 'Луксозна гостоприемница, Планинска хижа, Крайезерен хотел'],
    ['Размери', 'Малки, Средни, Големи', true],
    ['Ставки', 'Дневно, Месечно, Годишно', true],
    ['Стилове', 'Chukka, Cowboy, Combat, Chelsea'],
    ['Стоки', 'Облекла, Книги, Настолни игри'],
    ['Събития', 'Дипломирания, оздравявай, ново бебе', true],
    ['Теми', 'Доходи, Пенсиониране, Данъци', true],
    ['Типове', 'Тениски, Чаши, Чанти, Химикалки'],
    ['Удобства', 'WiFi, Басейн, Фитнес център, Кухненски бокс'],
    ['Услуги', 'Мъжко подстригване, Женско подстригване, Детско подстригване'],
    ['Училищни райони', 'Разглеждане, Класирания, Предложения', true],
    ['Цветя', 'Рози, маргаритки, лилии', true],
    ['Цени', 'Под 10 $, 50 – 100 $, Над 100 $', true],
  ]],
  ['Croatian', [
    ['Alati', 'Elektrika, pneumatika, hidraulika', true],
    ['Četvrti', 'Siget, Novi Zagreb – zapad'],
    ['Cijene', 'Ispod 10 USD, 50 – 100 USD, iznad 100 USD', true],
    ['Cvijeće', 'Ruže, tratinčice, ljiljani'],
    ['Diplomski programi', 'Poslovna administracija, računovodstvo, upravljanje ljudskim resursima'],
    ['Dnevne cijene', 'Samci, parovi, grupe', true],
    ['Dobne grupe', '40 i manje, 41 do 50, 51 do 60', true],
    ['Emisije', 'Kruna, Vikinzi, Ples sa zvijezdama'],
    ['Godišnji odmori', 'Otoci, putovanja automobilom, krstarenja', true],
    ['Istaknuti dijelovi', 'Što jesti, što vidjeti, što raditi', true],
    ['Izdvojeni hoteli', 'Luksuzno prenoćište, Alpine Lodge, hotel uz jezero'],
    ['Jezici', 'engleski, španjolski, kineski', true],
    ['Katalog usluga', 'Promjena ulja, provjera emisije ispušnih plinova, poravnanje kotača'],
    ['Kolegiji', 'Kreativno pisanje, strukture podataka, linearna algebra'],
    ['Lokacije', 'Sjeverna Amerika, Europa, Azija', true],
    ['Modeli', 'Corolla, Prius, Yaris'],
    ['Najprodavaniji', 'Ponuda dana, rođendanski buket, vrtni buket', true],
    ['Nastavni satovi', 'Defenzivna vožnja, vlasništvo stambene nekretnine za početnike', true],
    ['Ocjene', 'Najbolji prodavači, najjeftinije, najviše recenzija', true],
    ['Odjel', 'Uređaji, garaža, kućno kino', true],
    ['Odredišta', 'Pariz, Berlin, London'],
    ['Pogodnosti', 'Wi-Fi, bazen, fitness centar, mala kuhinja'],
    ['Polica osiguranja', 'Odgovornost treće strane, sudar, polica osiguranja, iznajmljivanje automobila'],
    ['Ponude', 'Proizvodi na sniženju, kupite jedan i drugi dobijte besplatno, popusti za studente', true],
    ['Prigode', 'Diploma, Ozdravi, Nova beba', true],
    ['Razredi', 'Diamond, Premium, Premium Plus', true],
    ['Roba', 'Odjeća, knjige, društvene igre'],
    ['Robne marke', 'Windows, Xbox, Skype'],
    ['Školska područja', 'Istraživanje, rangiranja, prijedlozi', true],
    ['Stavke', 'Prijenosna računala, televizori, igraće konzole'],
    ['Stilovi', 'Poluvisoke čizme, kaubojske čizme, vojničke čizme, gležnjače'],
    ['Što', 'Cvijeće, slatkiši, darovne kartice', true],
    ['Tarife', 'Dnevno, mjesečno, godišnje', true],
    ['Teme', 'Prihod, mirovina, porezi', true],
    ['Tko', 'Za njega, za nju, za parove', true],
    ['Usluge', 'Muška frizura, ženska frizura, dječja frizura'],
    ['Veličine', 'Malo, srednje, veliko', true],
    ['Vozila', 'Kompaktna vozila, teretni automobili, kabrioleti', true],
    ['Vrste', 'Majice, šalice, torbe, olovke'],
    ['Zašto', 'Rođendan, diplomiranje, godišnjica', true],
  ]],
  ['Czech', [
    ['Ceny', 'Pod 10 $, 50–100 $, přes 100 $', true],
    ['Cíle', 'Paříž, Berlín, Londýn'],
    ['Co', 'Květiny, svíčky, dárkové karty', true],
    ['Čtvrti', 'Václavské náměstí, Plzeň-sever, Špilberk'],
    ['Denní sazby', 'Jednotlivci, páry, skupiny', true],
    ['Doporučené hotely', 'Luxusní restaurace, alpská chata, hotel u jezera'],
    ['Dovolená', 'Ostrovy, výlety, výletní plavby', true],
    ['Hlavní události', 'Co ochutnat, co vidět, co dělat', true],
    ['Hodnocení', 'Nejprodávanější, nejlevnější, nejprohlíženější', true],
    ['Jazyky', 'Angličtina, španělština, čínština', true],
    ['Katalog služeb', 'Výměna oleje, kontrola smogu, vyrovnání pneumatik'],
    ['Kdo', 'Pro něj, pro ni, pro páry', true],
    ['Kurzy', 'Kreativní psaní, datové struktury, lineární algebra'],
    ['Květiny', 'Růže, Sedmikrásky, Lilie', true],
    ['Místa', 'Severní Amerika, Evropa, Asie', true],
    ['Modely', 'Corolla, Prius, Yaris'],
    ['Nabídky', 'Výprodej zboží, 1+1 zdarma, studentské slevy', true],
    ['Nástroje', 'Elektrické, pneumatické, hydraulické', true],
    ['Nejprodávanější', 'Výhoda dne, Narozeninová kytice, Zahradní kytice', true],
    ['Oddělení', 'Spotřebiče, garáž, domácí kino', true],
    ['Pojistné krytí', 'Odpovědnost za škodu, bouračka, ochrana, Pronájem automobilů'],
    ['Položky', 'Notebooky, televize, herní konzole'],
    ['Pořady', 'Perníkový táta, Vikingové, StarDance'],
    ['Proč', 'Narozeniny, promoce, výročí', true],
    ['Příležitosti', 'Promoce, Brzy se uzdrav, Narození dítěte', true],
    ['Sazby', 'Denní, měsíční, roční', true],
    ['Školní okrsky', 'Zkoumání, žebříčky, návrhy', true],
    ['Služby', 'Pánský účes, dámský účes, dětský účes'],
    ['Studijní programy', 'Obchodní administrativa, účetnictví, management lidských zdrojů'],
    ['Styly', 'Chukka, kovbojské, glády, Chelsea'],
    ['Témata', 'Příjem, důchod, daně', true],
    ['Třídy', 'Defenzivní jízda, Vlastnictví domu 101', true],
    ['Typy', 'Trička, hrnky, tašky, pera'],
    ['Věkové skupiny', 'Do 40 let včetně, od 41 do 50, od 51 do 60', true],
    ['Velikosti', 'Malé, střední, velké', true],
    ['Vozidla', 'Nižší střední třída, SUV, kabriolet', true],
    ['Vybavení', 'WiFi, bazén, posilovna, kuchyňka'],
    ['Zboží', 'Oblečení, knihy, deskové hry'],
    ['Značky', 'Windows, Xbox, Skype'],
    ['Známky', 'Diamond, Premium, Premium Plus', true],
  ]],
  ['Estonian', [
    ['Artiklid', 'Sülearvutid, telerid, mängukonsoolid'],
    ['Asukohad', 'Põhja-Ameerika, Euroopa, Aasia', true],
    ['Asumid', 'Vanalinn, Põhja-Tallinn, Pirita'],
    ['Enim müüdud', 'Päevapakkumine, sünnipäevakimp, aiakimp', true],
    ['Esiletõstetud hotellid', 'Luksushotell, alpimajake, järveäärne hotell'],
    ['Etendused', '„Mandariinid“, „Vehkleja“, „Klassikokkutulek“'],
    ['Hinded', 'Teemant, Premium, Premium Plus', true],
    ['Hinnad', 'Alla 10 €, 50–100 €, üle 100 €', true],
    ['Hinnangud', 'Populaarseimad, odavaimad, enim arvustusi', true],
    ['Kaubad', 'Riided, raamatud, lauamängud'],
    ['Kaubamärgid', 'Windows, Xbox, Skype'],
    ['Keeled', 'inglise, hispaania, hiina', true],
    ['Kes?', 'Mehele, naisele, paaridele', true],
    ['Kindlustuskate', 'Kolmanda poole vastutus, kokkupõrge, omavastutuse kindlustus, autorent'],
    ['Koolipiirkonnad', 'Tutvustus, pingeread, soovitused', true],
    ['Kraadiõppeprogrammid', 'Ärijuhtimine, raamatupidamine, personalijuhtimine'],
    ['Kursused', 'Loovkirjutamine, andmestruktuurid, lineaaralgebra'],
    ['Lilled', 'Roosid, karikakrad, liiliad', true],
    ['Maksumused', 'Päevane, kuine, aastane', true],
    ['Miks?', 'Sünnipäev, kooli lõpetamine, aastapäev', true],
    ['Mis?', 'Lilled, maiustused, kinkekaardid', true],
    ['Mudelid', 'Corolla, Prius, Yaris'],
    ['Osakond', 'Kodumasinad, garaaž, kodukino', true],
    ['Päevahinnad', 'Üksikinimesed, paarid, rühmad', true],
    ['Pakkumised', 'Lõpumüük, osta üks, saa üks, õppurisoodustus', true],
    ['Puhkused', 'Saared, autoreisid, kruiisid', true],
    ['Sihtkohad', 'Pariis, Berliin, London'],
    ['Sõidukid', 'Väikeauto, linnamaastur, kabriolett', true],
    ['Soodustused', 'WiFi, bassein, fitnessikeskus, miniköök'],
    ['Stiilid', 'Chukka, Cowboy, Combat, Chelsea'],
    ['Suurused', 'Väike, keskmine, suur', true],
    ['Sündmused', 'Koolilõpetamine, „head paranemist“, lapse sünd', true],
    ['Tähtsündmused', 'Mida süüa? Mida vaadata? Mida teha?', true],
    ['Teemad', 'Sissetulek, pension, maksud', true],
    ['Teenused', 'Meestelõikus, naistelõikus, lastelõikus'],
    ['Teenusekataloog', 'Õlivahetus, heitgaaside kontroll, rehvide joondamine'],
    ['Tööriistad', 'Elektriline, pneumaatiline, hüdrauliline', true],
    ['Tunnid', 'Ohutu sõit, Kodumajandus 101', true],
    ['Tüübid', 'T-krekli, krūzes, somas, pildspalvas'],
    ['Vanuserühmad', '40-aastased ja nooremad, 41- kuni 50-aastased, 51- kuni 60-aastased', true],
  ]],
  ['Hungarian', [
    ['A legtöbbet eladott termékek', 'A nap ajánlata, Születésnapi csokor, Kerti csokor', true],
    ['Ajánlatok', 'Akciós áruk, egyet fizet, kettőt kap, diákkedvezmények', true],
    ['Árak', '10 dollár alatt, 50és 100 dollár között, 100 dollár felett', true],
    ['Áruk', 'Ruházat, könyvek, társasjátékok'],
    ['Biztosítási fedezet', 'Felelősségbiztosítás, baleset, esernyő, autóbérlés'],
    ['Célállomások', 'Párizs, Berlin, London'],
    ['Díjak', 'Napi, havi, éves', true],
    ['Elemek', 'Laptopok, tévék, játékkonzolok'],
    ['Előadások', 'Trónok harca, Vaják, Maffiózók'],
    ['Értékelések', 'Legnépszerűbb, legolcsóbb, legtöbbször értékelt', true],
    ['Események', 'Ballagások, Jobbulást, Új baba', true],
    ['Eszközök', 'Elektromos, pneumatikus, hidraulikus', true],
    ['Helyek', 'Észak-Amerika, Európa, Ázsia', true],
    ['Járművek', 'Kompakt, SUV, kabrió', true],
    ['Kényelmi szolgáltatások', 'Wi-Fi, medence, edzőterem, főzőfülke'],
    ['Képzések', 'Gazdaságtudomány, könyvelés, HR-irányítás'],
    ['Ki', 'Ajándékok férfiaknak, nőknek, pároknak', true],
    ['Kiemelt szállodák', 'Luxusszálló, hegyi szállás, tóparti szálloda'],
    ['Korcsoportok', '40 és alatti, 41–50, 51–60', true],
    ['Márkák', 'Windows, Xbox, Skype'],
    ['Méretek', 'Kicsi, közepes, nagy', true],
    ['Mi', 'Virágok, édességek, ajándékkártyák', true],
    ['Miért', 'Születésnap, ballagás, évforduló', true],
    ['Modellek', 'Corolla, Prius, Yaris'],
    ['Napi árak', 'Egyszemélyes, kétszemélyes, csoportos', true],
    ['Nyaralás', 'Szigetek, autós túrák, körutazások', true],
    ['Nyelvek', 'Angol, spanyol, kínai', true],
    ['Összefoglaló', 'Ennivalók, látnivalók, tennivalók', true],
    ['Osztály', 'Háztartási gépek, garázs, házimozi', true],
    ['Osztályok', 'Defenzív vezetés, ingatlanvásárlási alapok', true],
    ['Osztályzatok', 'Gyémánt, Prémium, Prémium plusz', true],
    ['Stílusok', 'Sport, tenisz, utcai, gördeszkás'],
    ['Szolgáltatáskatalógus', 'Olajcsere, károsanyag-kibocsátási ellenőrzés, futómű-beállítás'],
    ['Szolgáltatások', 'Fodrászat férfiaknak, nőknek, gyerekeknek'],
    ['Tanfolyamok', 'Kreatív írás, adatszerkezetek, lineáris algebra'],
    ['Tankerületek', 'Felfedezés, rangsorok, javaslatok', true],
    ['Témák', 'Jövedelem, nyugdíj, adók', true],
    ['Típusok', 'Pólók, bögrék, táskák, tollak'],
    ['Városrészek', 'Pénzügyi negyed, Belváros, Főutca'],
    ['Virágok', 'Rózsa, százszorszép, liliom', true],
  ]],
  ['Latvian', [
    ['Aktualitātes', 'Ko ēst, ko apskatīt, ko darīt', true],
    ['Apdrošināšanas segums', 'Trešās puses atbildība, sadursme, lietussargs, automašīnu noma'],
    ['Apkaimes', 'Centrs, Āgenskalns, Vecāķi'],
    ['Atrašanās vietas', 'Ziemeļamerika, Eiropa, Āzija', true],
    ['Atvaļinājumi', 'Salas, braucieni, kruīzi', true],
    ['Atzīmes', 'Diamond, Premium, Premium Plus', true],
    ['Bestselleri', 'Dienas piedāvājums, dzimšanas dienas pušķis, dārza pušķis', true],
    ['Cenas', 'Mazāk par $10, $50-$100, vairāk nekā $100', true],
    ['Ērtības', 'WiFi, baseins, sporta klubs, virtuvīte'],
    ['Galamērķi', 'Parīze, Berlīne, Londona'],
    ['Ikdienas likmes', 'Neprecētie, pāri, grupas', true],
    ['Izmēri', 'Mazs, vidējs, liels', true],
    ['Izrādes', 'Kobra, Lauku sēta, Ģēnijs uzvalkā'],
    ['Kāpēc', 'Dzimšanas diena, izlaidums, jubileja', true],
    ['Kas', 'Ziedi, sveces, dāvanu kartes', true],
    ['Klases', 'Droša braukšana, īpašumtiesību 101', true],
    ['Kurš', 'Viņam, viņai, pāriem', true],
    ['Kursi', 'Radošā rakstīšana, datu struktūras, lineārā algebra'],
    ['Modeļi', 'Corolla, Prius, Yaris'],
    ['Nodaļa', 'Ierīces, garāža, mājas kinozāle', true],
    ['Notikumi', 'Izlaidumi, Veseļojies, Piedzimis bērniņš', true],
    ['Pakalpojumi', 'Vīriešu frizūras, sieviešu frizūras, bērnu frizūras'],
    ['Pakalpojumu katalogs', 'Eļļas maiņa, atgāzu pārbaude, savirzes regulēšana'],
    ['Piedāvājumi', 'Izpārdošanas preces, puscena, atlaides studentiem', true],
    ['Piedāvātās viesnīcas', 'Luksusa viesnīca, kalnu namiņš, viesnīca pie ezera'],
    ['Preces', 'Apģērbi, grāmatas, galda spēles'],
    ['Rīki', 'Elektriskie, pneimatiskie, hidrauliskie', true],
    ['Skolu rajoni', 'Iepazīšana, vērtējumi, ieteikumi', true],
    ['Stili', 'Čuka, kovboju, kaujas, Čelsija'],
    ['Studiju programmas', 'Uzņēmuma administrēšana, grāmatvedība, personāla vadība'],
    ['Tarifi', 'Dienas, mēneša, gada', true],
    ['Tēmas', 'Ienākumi, pensija, nodokļi', true],
    ['Transportlīdzekļi', 'Kompakts, apvidus, kabriolets', true],
    ['Valodas', 'Angļu, spāņu, ķīniešu', true],
    ['Vecuma grupas', '40 un mazāk, 41–50, 51–60', true],
    ['Veidi', 'T-krekli, krūzes, somas, pildspalvas'],
    ['Vērtējumi', 'Visvairāk pārdotie, lētākie, visvairāk atsauksmju', true],
    ['Vienumi', 'Klēpjdatori, televizori, spēļu konsoles'],
    ['Ziedi', 'Rozes, margrietiņas, lilijas', true],
    ['Zīmoli', 'Windows, Xbox, Skype'],
  ]],
  ['Lithuanian', [
    ['Amžiaus grupės', '40 ir jaunesni, nuo 41 iki 50, nuo 51 iki 60', true],
    ['Atostogos', 'Salos, kelionės, kruizai', true],
    ['Atrinkti viešbučiai', '„Luxury Inn“, „Alpine Lodge“, „Lakeside Hotel“'],
    ['Dienos tarifai', 'Vieni, poros, grupės', true],
    ['Draudimo apsauga', 'Trečiosios šalies atsakomybė, konfliktas, skėtis, automobilio nuoma'],
    ['Dydžiai', 'Mažas, vidutinis, didelis', true],
    ['Elementai', 'Nešiojamieji kompiuteriai, televizoriai, žaidimų konsolės'],
    ['Gėlės', 'Rožės, saulutės, lelijos', true],
    ['Įkainiai', 'Kasdien, kas mėnesį, kasmet', true],
    ['Įrankiai', 'Elektrinis, pneumatinis, hidraulinis', true],
    ['Įvertinimai', 'Geriausiai parduodami, pigiausi, dažniausiai peržiūrimi', true],
    ['Įvykiai', 'Mokyklos baigimas, greičiau pasveikite, kūdikis', true],
    ['Ką', 'Gėlės, žvakės, dovanų kortelės', true],
    ['Kaimynystė', 'Miesto centras, Fabijoniškės, Vilkpėdė'],
    ['Kainos', 'Mažiau nei 10 USD, 50–100 USD, daugiau nei 100 USD', true],
    ['Kalbos', 'Anglų, ispanų, kinų', true],
    ['Kas', 'Jam, jai, poroms', true],
    ['Kelionės tikslai', 'Paryžius, Berlynas, Londonas'],
    ['Klasės', 'Apsauginis vairavimas, namų nuosavybė 101', true],
    ['Kodėl', 'Gimtadienis, išleistuvės, jubiliejus', true],
    ['Laipsniai', '„Diamond“, „Premium“, „Premium Plus“', true],
    ['Modeliai', '„Corolla“, „Prius“, „Yaris“'],
    ['Mokyklos rajonai', 'Tyrimas, įvertinimai, pasiūlymai', true],
    ['Mokymo programos', 'Kūrybinis rašymas, duomenų struktūros, linijinė algebra'],
    ['Naujienos', 'Ką pavalgyti, ką pamatyti, ką nuveikti', true],
    ['Parodymai', '„The Voyage“, „Knights“, „American Dancer“'],
    ['Pasiūlymai', 'Prekių valymas, pirkite vieną, gaukite dar vieną, nuolaidos studentams', true],
    ['Paslaugos', 'Vyrų kirpimas, moterų kirpimas, vaikų kirpimas'],
    ['Paslaugų katalogas', 'Tepalų keitimas, dūmingumo patikra, padangų balansavimas'],
    ['Patogumai', '„Wi-Fi“, baseinas, sporto klubas, virtuvėlė'],
    ['Perkamiausi', 'Dienos pasiūlymas, gimtadienio puokštė, sodo puokštė', true],
    ['Prekės', 'Drabužiai, knygos, stalo žaidimai'],
    ['Prekių ženklai', '„Windows“, „Xbox“, „Skype“'],
    ['Programos laipsniui gauti', 'Verslo administravimas, apskaita, personalo valdymas'],
    ['Skyrius', 'Prietaisai, garažas, namų kino sistema', true],
    ['Stiliai', '„Chukka“, „Cowboy“, „Combat“, „Chelsea“'],
    ['Temos', 'Pajamos, pensija, mokesčiai', true],
    ['Tipai', 'Marškinėliai, puodeliai, krepšiai, rašikliai'],
    ['Transporto priemonės', '„Compact“, SUV, „Convertible“', true],
    ['Vietos', 'Šiaurės Amerika, Europa, Azija', true],
  ]],
  ['Maltese', [
    ['Btajjel', 'Gżejjer, Vjaġġi b\'Vettura, Kruċieri', true],
    ['Daqsijiet', 'Żgħir, Medju, Kbir', true],
    ['Destinazzjonijiet', 'Pariġi, Berlin, Londra'],
    ['Dipartiment', 'Apparati, Garaxx, Home theater', true],
    ['Ditti', 'Windows, Xbox, Skype'],
    ['Enfasi', 'X\'tiekol, X\'tara, X\'tagħmel', true],
    ['Faċilitajiet', 'WiFi, Pixxina, Ċentru tal-fitness, Kċina żgħira'],
    ['Fjuri', 'Ward, Margeriti, Ġilji', true],
    ['Għaliex', 'Għeluq is-Snin, Gradwazzjoni, Anniversarju', true],
    ['Għax', 'Fjuri, Xemgħat, Kards tar-rigali', true],
    ['Għodod', 'Elettriku, Pnewmatiku, Idroliku', true],
    ['Gradi', 'Diamond, Premium, Premium Plus', true],
    ['Gruppi t’età', '40 u iżgħar, 41 sa 50, 51 sa 60', true],
    ['Id-distretti tal-iskola', 'Esplora, Klassifikazzjonijiet, Suġġerimenti', true],
    ['Items', 'Laptops, Televiżjonijiet, Consoles tal-logħob'],
    ['Katalgu tas-servizz', 'Tibdil taż-żejt, Verifikar tal-ismogg, Allinjament tat-tajers'],
    ['Klassifikazzjonijiet', 'L-aqwa bejjiegħa, L-irħas, L-iktar li rawhom', true],
    ['Klassijiet', 'Sewqan difensiv, Sjieda tad-djar 101', true],
    ['Kopertura tal-assigurazzjoni', 'Assigurazzjoni ta’ terzi, Ħabta, Umbrella, Kiri ta\' karozzi'],
    ['Korsijiet', 'Kitba kreattiva, Strutturi tad-data, Alġebra lineari'],
    ['Li Jinbiegħu l-Aktar', 'Offerta tal-ġurnata, bukkett fjuri ta’ għeluq is-snin, Bukkett fjuri mill-ġnien', true],
    ['Lingwi', 'Ingliż, Spanjol, Ċiniż', true],
    ['Lukandi Msemmija', 'Luxury Inn, Alpine Lodge, Lakeside Hotel'],
    ['Min', 'Għalih, Għaliha, Għall-koppji', true],
    ['Mudelli', 'Corolla, Prius, Yaris'],
    ['Oġġetti', 'Ħwejjeġ, Kotba, Logħob fuq bord'],
    ['Okkażjonijiet', 'Gradwazzjonijiet, Fejqan, Tarbija ġdida', true],
    ['Postijiet', 'L-Amerika ta\' Fuq, l-Ewropa, l-Asja', true],
    ['Prezzijiet vantaġġużi', 'Affarijiet bi skontijiet kbar, Ixtri wieħed u tingħata ieħor b\'xejn, Skontijiet tal-istudenti', true],
    ['Prezzijiet', 'Taħt l-$10, $50-$100, \'Il fuq minn $100', true],
    ['Programmi ta\' lawrji', 'Amministrazzjoni tan-negozju, Kontabilità, Ġestjoni tar-Riżorsi Umani'],
    ['Rati ta\' kuljum', 'Persuni waħedhom, Koppji, Gruppi', true],
    ['Rati', 'Ta\' kuljum, Ta\' kull xahar, Annwali', true],
    ['Servizzi', 'Qatgħa xagħar tal-irġiel, qatgħa xagħar tan-nisa, qatgħa xagħar tat-tfal'],
    ['Spettakli', 'The Voyage, Knights, American Dancer'],
    ['Stili', 'Chukka, Cowboy, Combat, Chelsea'],
    ['Suġġetti', 'Dħul, Irtirar, Taxxi', true],
    ['Tipi', 'T-Shirts, Maggs, Basktijiet, Pinen'],
    ['Vetturi', 'Compact, SUV, Convertible', true],
    ['Viċinanzi', 'Financial district, SOMA, North Beach'],
  ]],
  ['Romanian', [
    ['Acoperirea asigurării', 'Răspundere civilă față de terți, în caz de coliziune, cu spectru larg, la închiriere vehicul'],
    ['Articole', 'Laptopuri, televizoare, console de jocuri'],
    ['Bunuri', 'Îmbrăcăminte, cărți, jocuri de societate'],
    ['Cartiere', 'Districtul financiar, SoMa, North Beach'],
    ['Catalog de servicii', 'Schimb de ulei, testarea emisiilor, alinierea roților'],
    ['Ce', 'Flori, dulciuri, carduri cadou', true],
    ['Cele mai vândute', 'Oferta zilei, buchet de aniversare, buchet de grădină', true],
    ['Cine', 'Pentru el, pentru ea, pentru cupluri', true],
    ['Cursuri', 'Scris creativ, structuri de date, algebră liniară'],
    ['De ce', 'Zi de naștere, absolvire, aniversare', true],
    ['Departament', 'Electrocasnice, garaj, sisteme Home Theater', true],
    ['Destinații', 'Paris, Berlin, Londra'],
    ['Districte școlare', 'Explorați, evaluări, sugestii', true],
    ['Dotări', 'WiFi, piscină, centru de fitness, chicinetă'],
    ['Emisiuni', 'The Voyage, Knights, American Dancer'],
    ['Evaluări', 'Cele mai bine vândute, cele mai ieftine, cu recenziile cele mai bune', true],
    ['Flori', 'Trandafiri, margarete, lilieci', true],
    ['Grupuri de vârstă', '40 și sub, 41-50, 51-60', true],
    ['Hoteluri recomandate', 'Luxury Inn, Alpine Lodge, Lakeside Hotel'],
    ['Instrumente', 'Electric, pneumatic, hidraulic', true],
    ['Limbi', 'Engleză, spaniolă, chineză', true],
    ['Locații', 'America de Nord, Europa, Asia', true],
    ['Mărci', 'Windows, Xbox, Skype'],
    ['Mărimi', 'Mic, mediu, mare', true],
    ['Modele', 'Corolla, Prius, Yaris'],
    ['Momente importante', 'Ce puteți mânca?, Ce puteți vedea?, Ce puteți face?', true],
    ['Note', 'Diamond, Premium, Premium Plus', true],
    ['Ocazii', 'Absolvire, însănătoșiri, bebeluș nou', true],
    ['Oferte', 'Articole cu preț redus, două articole la prețul unuia, reduceri pentru elevi', true],
    ['Ore', 'Condus preventiv, introducere în deținerea unei locuințe', true],
    ['Prețuri zilnice', 'Persoane necăsătorite, cupluri, grupuri', true],
    ['Prețuri', 'Sub 10 dolari, între 50 și 100 dolari, peste 100 dolari', true],
    ['Programe educaționale', 'Administrație afaceri, contabilitate, management resurse umane'],
    ['Servicii', 'Tuns bărbați, tuns femei, tuns copii'],
    ['Stiluri', 'Chukka, de cowboy, militare, Chelsea'],
    ['Subiecte', 'Venituri, pensionare, taxe', true],
    ['Tarife', 'Zilnic, lunar, anual', true],
    ['Tipuri', 'Tricouri, căni, pungi, pixuri'],
    ['Vacanțe', 'Insule, călătorii cu mașina, croaziere', true],
    ['Vehicule', 'Compact, SUV, decapotabil', true],
  ]],
  ['Slovak', [
    ['Ceny', 'Do 10 $, 50 $ – 100 $, nad 100 $', true],
    ['Čo', 'Kvety, sviečky, darčekové karty', true],
    ['Denné sadzby', 'Jednotlivci, páry, skupiny', true],
    ['Destinácie', 'Paríž, Berlín, Londýn'],
    ['Dovolenka', 'Ostrovy, výlety, výletné plavby', true],
    ['Hlavné udalosti', 'Čo ochutnať, čo vidieť, čo robiť', true],
    ['Hodnotenia', 'Najpredávanejšie, najlacnejšie, najčastejšie hodnotené', true],
    ['Jazyky', 'Angličtina, španielčina, čínština', true],
    ['Katalóg služieb', 'Výmena oleja, kontrola emisií, vyváženie pneumatík'],
    ['Kto', 'Pre neho, pre ňu, pre páry', true],
    ['Kurzy', 'Kreatívne písanie, Dátové štruktúry, Lineárna algebra'],
    ['Kvety', 'Ruže, sedmokrásky, ľalie', true],
    ['Miesta', 'Severná Amerika, Európa, Ázia', true],
    ['Modely', 'Corolla, Prius, Yaris'],
    ['Najpredávanejšie', 'Ponuka dňa, narodeninová kytica, záhradná kytica', true],
    ['Nástroje', 'Elektrické, pneumatické, hydraulické', true],
    ['Oddelenie', 'Spotrebiče, garáž, domáce kino', true],
    ['Poistné krytie', 'Zodpovednosť za škodu, nehoda, ochrana, prenájom vozidiel'],
    ['Položky', 'Notebooky, televízory, herné konzoly'],
    ['Ponuky', 'Výpredaj tovaru, 1+1 zdarma, študentské zľavy', true],
    ['Prečo', 'Narodeniny, promócia, výročie', true],
    ['Príležitosti', 'Promócie, skoré uzdravenie, narodenie dieťatka', true],
    ['Relácie', 'Crown, Stranger Things, Oteckovia'],
    ['Sadzby', 'Denné, mesačné, ročné', true],
    ['Školské obvody', 'Preskúmanie, rebríčky, návrhy', true],
    ['Služby', 'Pánsky účes, dámsky účes, detský účes'],
    ['Študijné programy', 'Obchodná administratíva, účtovníctvo, manažment ľudských zdrojov'],
    ['Štvrte', 'Hlavné námestie, Žilina – centrum, Rača'],
    ['Štýly', 'Chukka, kovbojský, lakovky, Chelsea'],
    ['Témy', 'Príjem, dôchodok, dane', true],
    ['Tovar', 'Oblečenie, knihy, stolné hry'],
    ['Triedy', 'Defenzívna jazda, Vlastníctvo domu 101', true],
    ['Typy', 'Tričká, hrnčeky, tašky, perá'],
    ['Veková skupiny', '40 a menej, 41 až 50, 51 až 60', true],
    ['Veľkosti', 'Malé, stredné, veľké', true],
    ['Vozidlá', 'Nižšia stredná trieda, SUV, kabriolet', true],
    ['Vybavenie', 'Wi-Fi, bazén, posilňovňa, kuchynka'],
    ['Vybrané hotely', 'Luxusná reštaurácia, alpská chata, hotel pri jazere'],
    ['Značky', 'Windows, Xbox, Skype'],
    ['Známky', 'Diamond, Premium, Premium Plus', true],
  ]],
  ['Slovenian', [
    ['Blagovne znamke', 'Windows, Xbox, Skype'],
    ['Cene', 'Pod 10 USD, od 50 do 100 USD, nad 100 USD', true],
    ['Diplomski programi', 'Vodenje podjetij, računovodstvo, upravljanje kadrov'],
    ['Dnevne cene', 'Samske osebe, pari, skupine', true],
    ['Dodatna ponudba', 'WiFi, bazen, fitnes, čajna kuhinja'],
    ['Dogodki', 'Maturacije, ozdravi, novorojenček', true],
    ['Elementi', 'Prenosniki, televizorji, igralne konzole'],
    ['Izdelki', 'Oblačila, knjige, družabne igre'],
    ['Izpostavljeni hoteli', 'Razkošen hotel, gorska koča, hotel ob jezeru'],
    ['Izpostavljeno', 'Restavracije, ogledi, dejavnosti', true],
    ['Jeziki', 'Angleščina, španščina, kitajščina', true],
    ['Kaj', 'Cvetje, sladkarije, darilni boni', true],
    ['Katalog storitev', 'Menjava olja, preverjanje izpustov, poravnava koles'],
    ['Kraji', 'Pariz, Berlin, London'],
    ['Lokacije', 'Severna Amerika, Evropa, Azija', true],
    ['Mestne četrti', 'Murgle, Fužine, Bežigrad'],
    ['Mnenja', 'Najbolje prodajani, najcenejši, z največ ocenami', true],
    ['Modeli', 'Corolla, Prius, Yaris'],
    ['Najbolj prodajano', 'Ponudba dneva, Rojstnodnevni šopek, Vrtni šopek', true],
    ['Ocene', 'Diamantni, Premium, Premium Plus', true],
    ['Oddaje', 'Preživetje v divjini, Zvezde plešejo, Naša mala klinika'],
    ['Oddelek', 'Gospodinjski aparati, garaža, domači kino', true],
    ['Orodja', 'Električna, pnevmatična, hidravlična', true],
    ['Počitnice', 'Otoki, potovanje z avtomobilom, križarjenje', true],
    ['Ponudbe', 'Odprodaja, ob nakupu enega je drugi izdelek brezplačen, študentski popusti', true],
    ['Predavanja', 'Kreativno pisanje, Podatkovne strukture, Linearna algebra'],
    ['Razredi', 'Defenzivna vožnja, Osnove lastništva nepremičnin', true],
    ['Rože', 'Vrtnice, marjetice, lilije', true],
    ['Slogi', 'Gležnarji, kavbojski, gojzarji, bulerji'],
    ['Šolska območja', 'Raziskovanje, lestvice, predlogi', true],
    ['Starostna skupina', '40 in manj, 41 do 50, 51 do 60', true],
    ['Storitve', 'Moško striženje, žensko striženje, otroško striženje'],
    ['Tarife', 'Na dan, na mesec, na leto', true],
    ['Teme', 'Prihodki, upokojitev, davki', true],
    ['Velikosti', 'S, M, L', true],
    ['Vozila', 'Majhen, SUV, kabriolet', true],
    ['Vrste', 'Majice, skodelice, torbe, pisala'],
    ['Za koga', 'Zanj, zanjo, za pare', true],
    ['Zakaj', 'Rojstni dan, zaključek šolanja, obletnica', true],
    ['Zavarovalno kritje', 'Odgovornost drugih oseb, zavarovanje za primer trčenja, kritje, najem avtomobilov'],
  ]],
  ['Albanian', [
    ['Artikuj', 'Laptopë, televizorë, konsola lojërash'],
    ['Automjete', 'Kompakte, SUV, kabriolet', true],
    ['Çfarë', 'Lule, qirinj, karta dhuratë', true],
    ['Çmimet', 'Nën 10 dollarë, 50 deri në 100 dollarë, mbi 100 dollarë', true],
    ['Çmimet e përditshme', 'Teke, në çift, në grupe', true],
    ['Departament', 'Pajisje, garazh, sistem kinemaje në shtëpi', true],
    ['Destinacione', 'Paris, Berlin, Londër'],
    ['Distrikte shkollore', 'Eksploro, renditjet, sugjerimet', true],
    ['Grupmoshat', 'Deri në 40, 41 deri në 50, 51 deri në 60', true],
    ['Gjuhët', 'Anglisht, spanjisht, kinezisht', true],
    ['Hotelet e spikatura', 'Han luksoz, shtëpizë alpine, hotel buzë liqenit'],
    ['Katalogu i shërbimeve', 'Ndërrimi i vajit, kontrolli për smog, drejtvendosja e rrotave'],
    ['Komoditete', 'Wi-Fi, pishinë, qendër fitnesi, aneks kuzhine'],
    ['Kurse', 'Shkrim krijues, struktura të të dhënave, algjebër lineare'],
    ['Kush', 'Për meshkuj, për femra, për çifte', true],
    ['Lagjet', 'Distrikti financiar, SOMA, North Beach'],
    ['Lulet', 'Trëndafila, margarita, zambakë', true],
    ['Llojet', 'Bluza me mëngë të shkurtra, filxhanë, çanta, stilolapsa'],
    ['Madhësitë', 'E vogël, mesatare, e madhe', true],
    ['Mallra', 'Veshje, libra, lojëra tavoline'],
    ['Marka', 'Windows, Xbox, Skype'],
    ['Mbulimi i sigurimeve', 'Përgjegjësia e palës së tretë, përplasje, mbulimi, makina me qira'],
    ['Me interes', 'Gjëra për të ngrënë, për të parë dhe për të bërë', true],
    ['Më të shiturat', 'Oferta e ditës, buqetë për ditëlindje, buqetë kopshti', true],
    ['Mësime', 'Udhëzimet për drejtim të kujdesshëm, zotërim të shtëpisë', true],
    ['Modele', 'Corolla, Prius, Yaris'],
    ['Ngjarjet', 'Diplomime, shërim i shpejtë, lindje e foshnjës', true],
    ['Notat', 'Diamant, Premium, Premium Plus', true],
    ['Oferta', 'Artikujt e mbylljes, bli një, merr një falas, ulje për studentët', true],
    ['Programe për diplomë', 'Administrim biznesi, kontabilitet, menaxhim i burimeve njerëzore'],
    ['Pse', 'Ditëlindje, diplomim, përvjetor', true],
    ['Pushime', 'Ishuj, udhëtime rrugore, lundrime', true],
    ['Shërbime', 'Prerje flokësh për meshkuj, për femra dhe për fëmijë'],
    ['Shfaqje', 'The Voyage, Knights, American Dancer'],
    ['Stile', 'Chukka, kauboj, luftim, Chelsea'],
    ['Tarifat', 'Ditore, mujore, vjetore', true],
    ['Temat', 'Të ardhurat, pensioni, tatimet', true],
    ['Vegla', 'Elektrike, pneumatike, hidraulike', true],
    ['Vendndodhjet', 'Amerika e Veriut, Evropë, Azi', true],
    ['Vlerësimet', 'Më të shiturat, më të lirat, më të komentuarat', true],
  ]],
  ['Bosnian', [
    ['Alatke', 'Električni, pneumatski, hidraulični', true],
    ['Brendovi', 'Windows, Xbox, Skype'],
    ['Cijene', 'Ispod 10 USD, 50–100 USD, preko 100 USD', true],
    ['Cvijeće', 'Ruže, tratinčice, ljiljani', true],
    ['Dijelovi grada', 'Vratnik, Bistrik, Novo Sarajevo'],
    ['Diplomski programi', 'Poslovna administracija, računovodstvo, upravljanje ljudskim resursima'],
    ['Dnevne cijene', 'Pojedinci, parovi, grupe', true],
    ['Dob grupe', '40 i ispod, 41 do 50, 51 do 60', true],
    ['Emisije', 'Pressing, Ritam Balkana, Nikad nije kasno'],
    ['Istaknuto', 'Šta jesti, šta gledati, šta raditi', true],
    ['Izdvojeni hotel', 'Luksuzno boravište, alpska kuća, hotel kraj jezera'],
    ['Jezici', 'engleski, španski, kineski', true],
    ['Katalog usluga', 'Promjena ulja, provjera smoga, balansiranje guma'],
    ['Ko', 'Za njega, za nju, za parove', true],
    ['Lokacije', 'Sjeverna Amerika, Evropa, Azija', true],
    ['Mišljenja', 'Najprodavanije, najjeftinije, najčešće pregledano', true],
    ['Modeli', 'Corolla, Prius, Yaris'],
    ['Najprodavaniji', 'Dogovor dana, rođendanski buket, Baštenski buket', true],
    ['Nastava', 'Odbrambena vožnja, sve o vlasništvu nad kućom', true],
    ['Ocjene', 'Diamond, Premium, Premium Plus', true],
    ['Odjel', 'Kućni aparati, garaža, kućno kino', true],
    ['Odmori', 'Ostrva, izleti, krstarenja', true],
    ['Odredišta', 'Pariz, Berlin, London'],
    ['Pokriće osiguranja', 'Odgovornost treće strane, sudar, krovno osiguranje, iznajmljivanje automobila'],
    ['Ponude', 'Posljednji komadi, dva po cijeni jednog, studentski popusti', true],
    ['Prilike', 'Diplome, Ozdravi, Nova beba', true],
    ['Roba', 'Odjeća, knjige, društvene igre'],
    ['Sadržaji', 'WiFi, bazen, fitnes centar, čajna kuhinja'],
    ['Školski okruzi', 'Istraživanje, rangiranja, prijedlozi', true],
    ['Šta', 'Cvijeće, bombone, poklon kartice', true],
    ['Stavke', 'Laptopovi, televizori, igraće konzole'],
    ['Stilovi', 'Duboke, kaubojske, vojničke, elegantne'],
    ['Stope', 'Dnevno, mjesečno, godišnje', true],
    ['Tečajevi', 'Kreativno pisanje, strukture podataka, linearna algebra'],
    ['Teme', 'Prihod, penzija, porezi', true],
    ['Tipovi', 'Majice, šolje, torbe, olovke'],
    ['Usluge', 'Muško šišanje, žensko šišanje, šišanje djece'],
    ['Veličine', 'Malo, srednje, veliko', true],
    ['Vozila', 'Mali automobil, SUV, kabriolet', true],
    ['Zašto', 'Rođendan, diplomiranje, godišnjica', true],
  ]],
  ['Icelandic', [
    ['Áfangastaðir', 'París, Berlín, London'],
    ['Aldurshópar', '40 og yngri, 41 til 50, 51 til 60', true],
    ['Atriði', 'Fartölvur, sjónvörp, leikjatölvur'],
    ['Auglýst hótel', 'Luxury Inn, Alpine Lodge, Lakeside Hotel'],
    ['Bekkir', 'Diamond, Premium, Premium Plus', true],
    ['Blóm', 'Rósir, fagurfíflar, liljur', true],
    ['Deild', 'Tæki, bílskúr, hitari fyrir heimili', true],
    ['Einkunnir', 'Vinsælustu vörurnar, ódýrast, mest skoðað', true],
    ['Farartæki', 'Smábíll, jeppi, blæjubíll', true],
    ['Flokkar', 'Að forðast árekstra, Fasteignahald 101', true],
    ['Frí', 'Eyjar, bíltúrar, siglingar', true],
    ['Gerðir', 'Corolla, Prius, Yaris'],
    ['Hápunktar', 'Hvar er best að borða, hvað á að skoða, hvað á að gera', true],
    ['Hvað', 'Blóm, sælgæti, gjafakort', true],
    ['Hver', 'Fyrir hann, fyrir hana, fyrir pör', true],
    ['Hverfi', 'Fjármálahverfið, SOMA, North Beach'],
    ['Hvers vegna', 'Afmæli, útskriftir, merkisdagar', true],
    ['Námskeið', 'Skapandi skrif, gagnaskipan, línuleg algebra'],
    ['Prófgráður', 'Rekstur fyrirtækja, bókhald, mannauðsstjórnun'],
    ['Skólahverfi', 'Skoða, röðun, tillögur', true],
    ['Staðsetningar', 'Norður-Ameríka, Evrópa, Asía', true],
    ['Stærðir', 'Lítið, meðalstórt, stórt', true],
    ['Stílsnið', 'Chukka, Cowboy, Combat, Chelsea'],
    ['Söluhæst', 'Tilboð dagsins, afmælisblómvöndur, blómvöndur úr garðinu', true],
    ['Tegundir', 'Stuttermabolir, krúsir, töskur, pennar'],
    ['Tilboð', 'Lagerútsala, 2 fyrir 1, nemendaafsláttur', true],
    ['Tilefni', 'Útskriftir, batakveðjur, nýtt barn', true],
    ['Tungumál', 'Enska, spænska, kínverska', true],
    ['Umfang tryggingar', 'Þriðju aðila ábyrgð, árekstur, Regnhlíf, bílaleiga'],
    ['Umfjöllunarefni', 'Tekjur, eftirlaun, skattar', true],
    ['Verð', 'Undir 10 USD, 50-100 UDS, yfir100 USD', true],
    ['Verð á dag', 'Einhleypir, pör, hópar', true],
    ['Verðlagning', 'Daglega, mánaðarlega, árlega', true],
    ['Verkfæri', 'Rafknúin, loftknúin, vökvaknúin', true],
    ['Vörumerki', 'Windows, Xbox, Skype'],
    ['Vörur', 'Fatnaður, bækur, borðspil'],
    ['Þægindi', 'Þráðlaust net, sundlaug, líkamsræktarstöð, eldhúskrókur'],
    ['Þættir', 'The Voyage, Knights, American Dancer'],
    ['Þjónusta', 'Herraklipping, dömuklipping, barnaklipping'],
    ['Þjónustuskrá', 'Olíuskipti, loftgæðaathugun, hjólabarðastilling'],
  ]],
  ['Macedonian', [
    ['Алати', 'Електрика, пневматици, хидраулика', true],
    ['Бестселери', 'Зделка на денот, роденденски букет, градинарски букет', true],
    ['Брендови', 'Windows, Xbox, Skype'],
    ['Возила', 'Компактен, теренец, кабриолет', true],
    ['Возрасни групи', '40 и под, 41 до 50, 51 до 60', true],
    ['Големини', 'Мало, средно, големо', true],
    ['Дневни тарифи', 'Самци, парови, групи', true],
    ['Добра', 'Облека, книги, друштвени игри'],
    ['Зделки', 'Распродажба за чистење производи, бесплатен производ со купен производ, студентски попусти', true],
    ['Зошто', 'Роденден, дипломирање, годишнина', true],
    ['Јавни добра', 'WiFi, базен, центар за фитнес, чајна кујна'],
    ['Јазици', 'Англиски, шпански, кинески', true],
    ['Каталог на услуги', 'Менување на масло, проверка за издувни гасови, порамнување на пневматици'],
    ['Кој', 'За него, за неа, за парови', true],
    ['Курсеви', 'Креативно пишување, податочни структури, линеарна алгебра'],
    ['Локации', 'Северна Америка, Европа, Азија', true],
    ['Модели', 'Corolla, Prius, Yaris'],
    ['Нагласени', 'Што да се јаде, што да се види, што да се прави', true],
    ['Оддел', 'Апарати, гаража, домашно кино', true],
    ['Одмори', 'Острови, екскурзии, крстосувања', true],
    ['Одредишта', 'Париз, Берлин, Лондон'],
    ['Осигурителна покриеност', 'Одговорност од трета страна, судир, чадор, изнајмување автомобили'],
    ['Оценки', 'Дијамантски, премиум, премиум плус', true],
    ['Препорачани хотели', 'Луксузен комплекс со апартмани, планинска вила, хотел покрај езеро'],
    ['Прилики', 'Дипломирање, побрзо оздравување, ново бебе', true],
    ['Програми за студирање', 'Деловна администрација, сметководство, управување со човечки ресурси'],
    ['Рејтинзи', 'Бестселери, најевтини, најпрегледувани', true],
    ['Соседства', 'Финансиска област, SOMA, Норт Бич'],
    ['Ставки', 'Лаптопи, телевизори, конзоли за играње'],
    ['Стилови', 'Чука, каубојски, војнички, челси'],
    ['Тарифи', 'Дневно, месечно, годишно', true],
    ['Теми', 'Приход, пензија, даноци', true],
    ['Типови', 'Маици, шолји, чанти, пенкала'],
    ['Услуги', 'Машка фризура, женска фризура, детска фризура'],
    ['Училишни области', 'Истражување, оценки, предлози', true],
    ['Цвеќе', 'Рози, маргаритки, лилии', true],
    ['Цени', 'Под 10 $, 50 $–100 $, над 100 $', true],
    ['Часови', 'Основи на совесното возење, поседувањето дом', true],
    ['Шоуа', 'The Voyage, Knights, American Dancer'],
    ['Што', 'Цвеќиња, бонбони, честитки', true],
  ]],
  ['Serbian', [
    ['Akademski programi', 'Poslovna administracija, računovodstvo, upravljanje ljudskim resursima'],
    ['Alatke', 'Električni, pneumatski, hidraulični', true],
    ['Artikli', 'Laptopovi, televizori, konzole'],
    ['Brendovi', 'Windows, Xbox, Skype'],
    ['Časovi', 'Defanzivna vožnja', true],
    ['Cene', 'Manje od 10 USD, od 50 do 100 USD, više od 100 USD', true],
    ['Cveće', 'Ruže, tratinčice, ljiljani', true],
    ['Delovi grada', 'Poslovna zona, Novi Beograd, Beograd'],
    ['Dnevne cene', 'Samci, parovi, grupe', true],
    ['Događaji', 'Diplome, brz oporavak, nova beba', true],
    ['Emisije', '24 minuta sa Zoranom Kesićem, Nikad nije kasno, Šarenica'],
    ['Istaknuti hoteli', 'Luksuzni motel, koliba na Alpima, hotel na obali jezera'],
    ['Istaknuto', 'Šta jesti, šta videti, šta raditi', true],
    ['Jezici', 'Engleski, španski, kineski', true],
    ['Ko', 'Za njega, za nju, za parove', true],
    ['Kursevi', 'Kreativno pisanje, strukture podataka, linearna algebra'],
    ['Lokacije', 'Severna Amerika, Evropa, Azija', true],
    ['Modeli', 'Corolla, Prius, Yaris'],
    ['Najprodavanije', 'Ponuda dana, rođendanski buket, baštenski buket', true],
    ['Nivoi', 'Diamond, Premium, Premium Plus', true],
    ['Ocene', 'Dnevno, mesečno, godišnje', true],
    ['Odeljenje', 'Kućni aparati, garaža, kućni bioskop', true],
    ['Odmori', 'Ostrva, ekskurzije, krstarenja', true],
    ['Odredišta', 'Pariz, Berlin, London'],
    ['Pogodnosti', 'Wi-Fi, bazen, centar za fitnes, kuhinja u niši'],
    ['Ponude', 'Poslednji komadi, kupi dva po ceni za jedan, studentski popusti', true],
    ['Premija osiguranja', 'Odgovornost treće strane, sudar, kišobran, iznajmljivanje automobila'],
    ['Procene', 'Najbolji prodavci, najjeftinije, najviše ocena', true],
    ['Roba', 'Odeća, knjige, društvene igre'],
    ['Servisni katalog', 'Zamena ulja, provera smoga, poravnanje pneumatika'],
    ['Školski okrug', 'Istraživanje, ocene, predlozi', true],
    ['Šta', 'Cveće, sveće, poklon-kartice', true],
    ['Starosne grupe', '40 i manje, 41 do 50, 51 do 60', true],
    ['Stilovi', 'Duboke, kaubojke, kombatke, duboke na navlačenje'],
    ['Teme', 'Prihod, penzija, porezi', true],
    ['Tipovi', 'Majice, šolje, torbe, olovke'],
    ['Usluge', 'Muški frizer, ženski frizer, frizer za decu'],
    ['Veličine', 'Malo, srednje, veliko', true],
    ['Vozila', 'Kompaktno, SUV, kabriolet', true],
    ['Zašto', 'Rođendan, diplomiranje, godišnjica', true],
  ]],
  ['Japanese', [
    ['1 日あたりの料金', 'シングル、カップル、グループ', true],
    ['おすすめのホテル', 'ラグジュアリー イン、 アルパイン ロッジ、レイクサイド ホテル'],
    ['クラス', '安全運転、自宅の保全 101', true],
    ['コース', 'クリエイティブ ライティング、データ構造、線形代数'],
    ['サービス カタログ', 'オイル交換、排煙チェック、タイヤ アライメント'],
    ['サービス', '男性の散髪、女性のヘアカット、子供の散髪'],
    ['サイズ', '小、中、大', true],
    ['ショー', '旅、ナイト、アメリカン ダンサー'],
    ['スタイル', 'チャッカブーツ、カウボーイ、コンバット、チェルシー'],
    ['タイプ', 'T シャツ、マグ、バッグ、ペン'],
    ['ツール', '電気的、気圧的、水圧的', true],
    ['トピック', '収入、退職、税金', true],
    ['なぜ', '誕生日、卒業、記念日', true],
    ['ハイライト', '何を食べるか、何を見て、何をするか', true],
    ['ブランド', 'Windows、Xbox、Skype'],
    ['ベスト セラー', '本日のお買い得商品、誕生日ブーケ、ガーデン ブーケ', true],
    ['モデル', 'カローラ、プリウス、ヤリス'],
    ['休暇', '島、長距離ドライブ、クルーズ', true],
    ['何', '花、キャンディー、ギフト カード', true],
    ['価格', '10 ドル未満、50 ドルから 100ドル、100 ドル以上', true],
    ['保険担保範囲', '第三者責務、衝突、傘、レンタカー'],
    ['花', 'バラ、ヒナギク、ユリ', true],
    ['取引', 'クリアランス アイテム、お一人様 1 点限り、学生割引', true],
    ['商品', '衣類、書籍、ボード ゲーム'],
    ['場所', '北米、ヨーロッパ、アジア', true],
    ['学位課程', 'ビジネス アドミニストレーション、会計、人事管理'],
    ['学区', '探索、ランク付け、教唆', true],
    ['快適な設備', 'WiFi、プール、フィットネス センター、キチネット (簡易台所)'],
    ['成績', 'Diamond、Premium、Premium Plus', true],
    ['料率', '日単位、月単位、年単位', true],
    ['目的地', 'パリ、ベルリン、ロンドン'],
    ['言語', '英語、スペイン語、中国語', true],
    ['評価', 'ベストセラー、最安値の、最も評価された', true],
    ['特別行事', '卒業、快気、出産', true],
    ['年齢グループ', '40 以下、41 から 50、51 から 60', true],
    ['誰が', '彼のため、彼女のため、カップルのため', true],
    ['車両', 'コンパクト、SUV、コンバーチブル', true],
    ['近隣地域', '金融街、SOMA、ノース ビーチ'],
    ['部署', 'アプライアンス、ガレージ、ホーム シアター', true],
    ['項目', 'ノート PC、テレビ、ゲーム コンソール'],
  ]],
  ['Russian', [
    ['Автомобили', 'Компактный, внедорожник, кабриолет', true],
    ['Возрастные группы', 'до 40, от 41 до 50, от 51 до 60', true],
    ['дипломные программы', 'Администрирование бизнеса, бухгалтерский учет, управление персоналом'],
    ['Ежедневные тарифы', 'Для одного, для двоих, для группы', true],
    ['Инструменты', 'Электрический, пневматический, гидравлический', true],
    ['Каникулы', 'Острова, поездки, круизы', true],
    ['Каталог услуг', 'Замена масла, проверка на чистоту выхлопа, развал-схождение шин'],
    ['Классы', 'Безопасное вождение, домовладение 101', true],
    ['Кто', 'Для него, для нее, для двоих', true],
    ['Курсы', 'Писательское мастерство, структуры данных, линейная алгебра'],
    ['Модели', 'Королла, Приус, Ярис'],
    ['Направления', 'Париж, Берлин, Лондон'],
    ['Основные сведения', 'Что поесть, что посмотреть, чем заняться', true],
    ['Отдел', 'Бытовая техника, автозапчасти, домашний кинотеатр', true],
    ['Оценки', 'Бриллиантовый, Премиум, Премиум-плюс', true],
    ['Пользующиеся успехом', 'Предложение дня, Букет на день рождения, Садовый букет', true],
    ['Популярные гостиницы', 'Гостиница класса люкс, высокогорная база отдыха, отель на берегу озера'],
    ['Почему', 'День рождения, выпускной, годовщина', true],
    ['Размеры', 'Маленький, средний, большой', true],
    ['Районов', 'Финансовый район, SOMA, Северный пляж'],
    ['Расположения', 'Северная Америка, Европа, Азия', true],
    ['Рейтинги', 'Пользующиеся успехом, самые недорогие, самые просматриваемые', true],
    ['События', 'Выпускной, выздоровление, новорожденный', true],
    ['Специальные предложения', 'Элементы распродажи, купи один — получи один в подарок, скидки для учащихся', true],
    ['Стили', 'Дезерты, ковбойские, тактические, челси'],
    ['Страховое покрытие', 'Ответственность перед третьими лицами, защита на случай столкновения, зонтичное покрытие, аренда автомобиля'],
    ['Тарифы', 'Ежедневно, ежемесячно, ежегодно', true],
    ['Телепередачи', 'The Voyage, Knights, American Dancer'],
    ['Темы', 'Доход, выходное пособие, уплата налогов', true],
    ['Типы', 'Футболки, кружки, сумки, ручки'],
    ['Товары', 'Одежда, Книги, Настольные игры'],
    ['Торговые марки', 'Windows, Xbox, Skype'],
    ['Удобства', 'Wi-Fi, бассейн, фитнес-центр, мини-кухня'],
    ['Услуг', 'Мужская стрижка, женская стрижка, детская стрижка'],
    ['Цветы', 'Розы, маргаритки, лилии', true],
    ['Цены', 'До 1000 рублей, 5000–10000 рублей, более 10000 рублей', true],
    ['Что', 'Цветы, конфеты, подарочные карты\'', true],
    ['Школьные районы', 'Обзор, ранжирование, предложения', true],
    ['Элементы', 'Ноутбуки, телевизоры, игровые консоли'],
    ['Языки', 'Английский, испанский, китайский', true],
  ]],
  ['Hebrew', [
    ['אירועים', 'טקסי סיום לימודים, החלמה מהירה, תינוק חדש', true],
    ['בתי מלון מוצגים', 'Luxury Inn,‏ Alpine Lodge,‏ Lakeside Hotel'],
    ['דגמים', 'קורולה, פריוס, יאריס'],
    ['דירוגים', 'רבי מכר, הזול ביותר, עם הכי הרבה ביקורות', true],
    ['הצגות', 'The Voyage, Knights, American Dancer'],
    ['חופשות', 'איים, מסעי דרכים, הפלגות', true],
    ['יעדים', 'פריס, ברלין, לונדון'],
    ['כיסוי ביטוח', 'חבות צד שלישי, התנגשות, מטרייה, השכרות רכב'],
    ['כלי רכב', 'קומפקטי, SUV, גג נפתח', true],
    ['כלים', 'חשמלי, פניאומטי, הידראולי', true],
    ['מדוע', 'יום הולדת, סיום לימודים, יום השנה', true],
    ['מה', 'פרחים, ממתקים, כרטיסי מתנה', true],
    ['מותגים', 'Windows,‏ Xbox,‏ Skype'],
    ['מחוזות בתי ספר', 'סיור, דירוגים, הצעות', true],
    ['מחירים', 'פחות מ- $10, $50-$100, מעל $100', true],
    ['מחלקה', 'מכשירי חשמל, חניה, מערכת קולנוע ביתי', true],
    ['מידות', 'קטן, בינוני, גדול', true],
    ['מיקומים', 'צפון אמריקה, אירופה, אסיה', true],
    ['משתתפים', 'עבורו, עבורה, עבור זוגות', true],
    ['מתקנים', 'WiFi, בריכה, מרכז כושר, מטבחון'],
    ['נושאים', 'הכנסה, פרישה, מסים', true],
    ['סגנונות', 'צ\'וקה, קאובוי, לחימה, צ\'לסי'],
    ['סוגים', 'חולצות טריקו, ספלים, תיקים, עטים'],
    ['סחורה', 'ביגוד, ספרים, משחקי לוח'],
    ['עסקאות', 'פריטי מכירת חיסול, קנה אחד קבל אחד, הנחות לסטודנטים', true],
    ['פרחים', 'ורדים, חבצלות, לילך', true],
    ['פריטים', 'מחשבים נישאים, טלוויזיות, משחקי קונסולות'],
    ['ציונים', 'Diamond,‏ Premium,‏ Premium Plus', true],
    ['קבוצות גיל', '40 ומטה, 41 עד 50, 51 עד 60', true],
    ['קורסים', 'כתיבה יצירתית, מבני נתונים, אלגברה ליניארית'],
    ['קטלוג שירותים', 'החלפת שמן, בדיקת ערפיח, איזון צמיגים'],
    ['רבי מכר', 'המבצע היומי, זר יום הולדת, זר פרחי גן', true],
    ['רגעים בולטים', 'מה לאכול, מה לראות, מה לעשות', true],
    ['שיעורים', 'נהיגה הגנתית, מבוא לבעלות על בית', true],
    ['שירותים', 'תספורת גברים, תספורת נשים, תספורת ילדים'],
    ['שכונות', 'מחוז פיננסי, SOMA, ‏נורת\' ביץ\''],
    ['שערים', 'יומי, חודשי, שנתי', true],
    ['שפות', 'אנגלית, ספרדית, סינית', true],
    ['תוכניות לתארים', 'ניהול עסקי, חשבונאות, ניהול משאבי אנוש'],
    ['תעריפים יומיים', 'יחידים, זוגות, קבוצות', true],
  ]],
  ['Arabic', [
    ['إجازات', 'جزر، طرق، رحلات بحرية', true],
    ['احجام', 'صغيرة، متوسطة، كبيرة', true],
    ['أخبار هامة', 'ما يجب تناوله، ما يجب رؤيته، ما يجب فعله', true],
    ['أزهار', 'الورود، الزنبق، الزنبق', true],
    ['اكثر الكتب مبيعا', 'صفقة اليوم، باقة عيد الميلاد، باقة الحديقة', true],
    ['الاحياء', 'المنطقة المالية، SOMA، الشاطئ الشمالي'],
    ['الأدوات', 'كهربائي، هوائي، هايدروليكي', true],
    ['الأسعار اليومية', 'عزّاب، أزواج، مجموعات', true],
    ['الأسعار', 'أقل من 10 دولارات، 50-$100، أكثر من 100 دولار أمريكي', true],
    ['الأنواع', 'قمصان، أكواب، حقائب، أقلام'],
    ['التصنيفات', 'أفضل البائعين، الأرخص، الأكثر مراجعة', true],
    ['الدرجات', 'ألماسي، مميز، مميز إضافي', true],
    ['الدورات التدريبية', 'الكتابة الإبداعية، بنيات البيانات، الجبر الخطي'],
    ['الصفقات', 'عناصر التفريغ، اشتر واحد احصل على واحد، خصومات الطلاب', true],
    ['العروض', 'The Voyage, Knights, American Dancer'],
    ['العلامات التجارية', 'Windows، Xbox، Skype'],
    ['العناصر', 'أجهزة الكمبيوتر المحمولة والتلفزيون ووحدات تحكم اللعبة'],
    ['الفنادق المميزة', 'نزل فاخر، جبل الألب، فندق Lakeside'],
    ['القسم', 'أجهزة، مرآب، مسرح منزلي', true],
    ['اللغات', 'الإنجليزية، الإسبانية، الصينية', true],
    ['المجموعات العمرية', '40 وما دون، من 41 إلى 50، من 51 إلى 60', true],
    ['المركبات', 'صغيرة، عائلية، بدون سقف', true],
    ['المعدلات', 'يوميا، شهريا، سنويا', true],
    ['المواضيع', 'الدخل، التقاعد، الضرائب', true],
    ['المواقع', 'أمريكا الشمالية، أوروبا، آسيا', true],
    ['الوجهات', 'باريس، برلين، لندن'],
    ['أنماط', 'شوكة، راعي بقر، قتال، شيلسي'],
    ['برامج الدرجات', 'إدارة الأعمال، المحاسبة، إدارة الموارد البشرية'],
    ['بضائع', 'ملابس، كتب، ألعاب لوحية'],
    ['تغطية التأمين', 'مسؤولية الجهة الخارجية، تصادم، مظلة، تأجير السيارات'],
    ['خدمات', 'قصات شعر للرجال، قصات شعر نسائية، قصات شعر للأطفال'],
    ['دروس', 'القيادة الدفاعية، دليل امتلاك منزل', true],
    ['طرازات', 'كورولا، بريس، ياريس'],
    ['كتالوج الخدمة', 'تغيير الزيت، فحص الضباب، محاذاة الإطارات'],
    ['لماذا', 'عيد الميلاد، التخرج، الذكرى السنوية', true],
    ['ماذا', 'أزهار، حلوى، بطاقات هدايا', true],
    ['من', 'له، لها، للأزواج', true],
    ['مناسبات', 'التخرج، الشفاء العاجل، مولود جديد', true],
    ['مناطق المدرسة', 'استكشاف وتصنيفات واقتراحات', true],
    ['وسائل راحة', 'WiFi، حمام سباحة، مركز اللياقة البدنية، المطبخ'],
  ]],
  ['SimplifiedChinese', [
    ['班级', '创意书写，数据结构，线性代数', true],
    ['部门', '设备、影院、家庭影院', true],
    ['场合', '毕业，康复，新生婴儿', true],
    ['畅销品', '当日特卖，生日花束，花园花束', true],
    ['车辆', '紧凑型车，SUV，敞篷车', true],
    ['承保范围', '第三方责任，碰撞，雨伞，汽车租赁'],
    ['大小', '小、中、大', true],
    ['等级', '钻石，高级，超高级', true],
    ['服务', '男士发型、女士发型、儿童发型'],
    ['服务目录', '油改、烟雾检查、油料对齐'],
    ['工具', '电、气压、电压', true],
    ['花卉', '玫瑰，菊花，百合', true],
    ['货物', '服装、书籍、棋盘游戏'],
    ['假期', '群岛、路线图、邮轮', true],
    ['价格', '低于 $10，$50-$100，超过 $1000', true],
    ['节目', 'The Voyage, Knights, American Dancer'],
    ['课程', '防御性驾驶，家庭所有权 101'],
    ['类型', 'T恤，杯子，包，笔'],
    ['亮点', '吃什么，看什么，做什么', true],
    ['每日費率', '单人，双人，团体', true],
    ['目的地', '巴黎、柏林、伦敦'],
    ['内容', '花、糖、礼品卡', true],
    ['年龄组', '40 和更小，41 到 50，51 到 60', true],
    ['频率', '每日，每月，每年', true],
    ['品牌', 'Windows、Xbox、Skype'],
    ['评级', '畅销品，最便宜，浏览次数最多', true],
    ['人员', '为他，为她，为情侣', true],
    ['设施', 'WiFi，游泳池，健身中心，厨房'],
    ['社区', '财务区，SOMA，北海滩'],
    ['特色酒店', '豪华旅馆、高山小屋、湖畔酒店'],
    ['位置', '北美、欧洲、亚洲', true],
    ['项目', '笔记本电脑、电视、游戏主机'],
    ['型号', 'Corolla、Prius、Yaris'],
    ['学区', '浏览、排名、建议', true],
    ['学位课程', '商务管理，会计，人力资源管理'],
    ['样式', 'Chukka, 牛仔, 战斗, 切尔西'],
    ['优惠', '清仓商品，买一送一，学生折扣', true],
    ['语言', '英语、西班牙语、中文', true],
    ['原因', '生日、毕业、周年', true],
    ['主题', '收入、停用、税费', true],
  ]],
  ['Malay', [
    ['Alat', 'Elektrik, Pneumatik, Hidraulik', true],
    ['Apa', 'Bunga, Gula-gula, Kad hadiah', true],
    ['Bahasa', 'Bahasa Inggeris, bahasa Sepanyol, Bahasa Cina', true],
    ['Barangan', 'Pakaian, Buku, Permainan papan'],
    ['Bunga', 'Mawar, Daisi, Lili', true],
    ['Daerah sekolah', 'Teroka, Penilaian, Cadangan', true],
    ['Destinasi', 'Paris, Berlin, London'],
    ['Gaya', 'Chukka, Cowboy, Combat, Chelsea'],
    ['Gred', 'Berlian, Premium, Premium Tambahan', true],
    ['Harga', 'Bawah $10, $50-100, Atas $1000', true],
    ['Hotel yang diketengahkan', 'Luxury Inn, Alpine Lodge, Lakeside Hotel'],
    ['Item', 'Komputer riba, TV, Konsol permainan'],
    ['Jabatan', 'Peralatan, Garaj, Teater rumah', true],
    ['Jenama', 'Windows, Xbox, Skype'],
    ['Jenis', 'Baju T, Mug, Beg, Pen'],
    ['Jualan paling laris', 'Tawaran hari ini, Sejambak hari jadi, Sejambak taman', true],
    ['Kadar harian', 'Bujang, Pasangan, Kumpulan', true],
    ['Kadar', 'Harian, Bulanan, Tahunan', true],
    ['Katalog perkhidmatan', 'Penukaran minyak, Pemeriksaan asap, Penjajaran tayar'],
    ['Kejiranan', 'Daerah kewangan, SOMA, Pantai Utara'],
    ['Kelas', 'Penulisan kreatif, Struktur data, Algebra linear', true],
    ['Kemudahan', 'WiFi, Kolam, Pusat kecergasan, Dapur kecil'],
    ['Kenapa', 'Hari jadi, Graduasi, Ulang tahun', true],
    ['Kenderaan', 'Kompak, SUV, Boleh Tukar', true],
    ['Kumpulan umur', '40 dan bawah 41 ke 50, 51 ke 60', true],
    ['Kursus', 'Pemanduan pertahanan, Pemilikan rumah 101'],
    ['Lokasi', 'Amerika Utara, Eropah, Asia', true],
    ['Majlis', 'Graduasi, Semoga sihat, Bayi baru', true],
    ['Model', 'Corolla, Prius, Yaris'],
    ['Penilaian', 'Terlaris, Termurah, Paling banyak disemak', true],
    ['Percutian', 'Pulau, Perjalanan jalan, Pelayaran', true],
    ['Perkhidmatan', 'Gunting rambut lelaki, Gunting rambut wanita, Gunting rambut kanak-kanak'],
    ['Perlindungan insurans', 'Liabiliti pihak ketiga, Perlanggaran, Payung, Penyewaan kereta'],
    ['Pertunjukkan', 'The Voyage, Knights, American Dancer'],
    ['Program ijazah', 'Pentadbiran perniagaan, Perakaunan, Pengurusan HR'],
    ['Saiz', 'Kecil, Sederhana, Besar', true],
    ['Siapa', 'Untuk dia, Untuk dia, Untuk pasangan', true],
    ['Sorotan', 'Apa yang hendak dimakan, Apa yang perlu dilihat, Apa yang perlu dilakukan', true],
    ['Tawaran', 'Item penghabisan, Beli satu dapat satu, Diskaun pelajar', true],
    ['Topik', 'Pendapatan, Persaraan, Cukai', true],
  ]],
  ['Hindi', [
    ['अवसर', 'स्नातक, स्वस्थ हो जाओ, नया बच्चा', true],
    ['आइटम', 'लैपटॉप्स, TV, गेम कंसोल्स'],
    ['आकार', 'छोटा, मध्यम, बड़ा', true],
    ['आयु समूह', '40 और इससे कम, 41 से 50, 51 से 60 तक', true],
    ['उपकरण', 'इलेक्ट्रिक, न्यूमेटिक, हाइड्रॉलिक', true],
    ['कौन', 'उसके लिए, उसके लिए, जोड़ों के लिए', true],
    ['क्या', 'फूल, कैंडीज़, उपहार कार्ड', true],
    ['क्यों', 'जन्मदिन, स्नातक, वर्षगाँठ', true],
    ['ग्रेड', 'डायमंड, प्रीमियम, प्रीमियम प्लस', true],
    ['छुट्टियाँ', 'आइलैंड्स, रोडट्रिप्स, क्रूज़', true],
    ['डिग्री प्रोग्राम्स', 'व्यवसाय व्यवस्थापन, अकाउंटिंग, HR प्रबंधन'],
    ['डील्स', 'क्लीयरेंस आइटम्स, एक खरीदें दूसरा पाएं, विद्यार्थी छूट', true],
    ['डेस्टिनेशन', 'पेरिस, बर्लिन, लंदन'],
    ['दरें', 'दैनिक, मासिक, वार्षिक', true],
    ['दैनिक दरें', 'एकल, युगल, समूह', true],
    ['पड़ोस', 'वित्तीय जिला, SOMA, उत्तरी समुद्र तट'],
    ['पाठ्यक्रम', 'रक्षात्मक ड्राइविंग, होम स्वामित्व 101'],
    ['प्रकार', 'टी-शर्ट, मग, बैग्स, पेन्स'],
    ['फ़ीचर्ड होटल', 'Luxury Inn, Alpine Lodge, Lakeside Hotel'],
    ['फूल', 'गुलाब, डेज़ीज़, लिलीज़', true],
    ['बीमा कवरेज', 'तृतीय पक्ष देयता, टकराव, छाता, कार का किराया'],
    ['ब्रांड्स', 'Windows, Xbox, Skype'],
    ['भाषाएँ', 'अंग्रेज़ी, स्पैनिश, चीनी', true],
    ['माल', 'कपड़े, पुस्तकें, बोर्ड गेम्स'],
    ['मूल्य', '$10, $50-$100 के अंतर्गत, $1000 से अधिक', true],
    ['मॉडल्स', 'कोरोला, प्रियस, यारिस'],
    ['रेटिंग', 'श्रेष्ठ विक्रेता, सबसे सस्ते, सबसे अधिक समीक्षा की गई', true],
    ['वर्गों', 'रचनात्मक लेखन, डेटा संरचनाएँ, रेखीय बीजगणित', true],
    ['वाहन', 'संकुचित, SUV, कनवर्ट करने योग्य', true],
    ['विद्यालय जिला', 'एक्सप्लोर, रैंकिंग, सुझाव', true],
    ['विभागों', 'उपकरण, गैराज, होम थिएटर', true],
    ['विषय', 'आय, सेवानिवृत्ति, कर', true],
    ['शैलियाँ', 'चुक्का, काउबॉय, कॉम्बैट, परीक्षक'],
    ['शो', 'The Voyage, Knights, American Dancer'],
    ['श्रेष्ठ विक्रेता', 'दिन की डील, जन्मदिन का गुलदस्ता, बगीचे का गुलदस्ता', true],
    ['सुविधाएँ', 'WiFi, पूल, फ़िटनेस सेंटर, किचनेट'],
    ['सेवा कैटलॉग', 'तेल परिवर्तन, Smog जाँच, टायर संरेखण'],
    ['सेवाएँ', 'पुरुष के बाल काटना, महिलाओं के बाल कटना, बच्चों के बाल कटना'],
    ['स्थानों', 'उत्तरी अमेरिका, यूरोप, एशिया', true],
    ['हाइलाइट्स', 'क्या खाना है, क्या देखना है, क्या करना है', true],
  ]],
  ['Thai', [
    ['กลุ่มอายุ', '40 และต่ำกว่า, 41 ถึง 50, 51 ถึง 60', true],
    ['การจัดอันดับ', 'ขายดีที่สุด, ราคาถูกที่สุด, ได้รับรีวิวมากที่สุด', true],
    ['เกรด', 'Diamond, Premium, Premium Plus', true],
    ['ขนาด', 'เล็ก, ปานกลาง, ใหญ่', true],
    ['ข้อเสนอ', 'สินค้าลดล้างสต็อก, ซื้อหนึ่งแถมหนึ่ง, ส่วนลดสำหรับนักเรียน', true],
    ['ขายดีที่สุด', 'ข้อเสนอประจำวัน, ช่อดอกไม้วันเกิด, ช่อดอกไม้ในสวน', true],
    ['เขตโรงเรียน', 'สำรวจ, การจัดอันดับ, คำแนะนำ', true],
    ['ความคุ้มครองของประกันภัย', 'ความรับผิดของบริษัทภายนอก, การชน, ความคุ้มครองเพิ่มเติม, การเช่ารถยนต์'],
    ['เครื่องมือ', 'ไฟฟ้า, นิวเมติกส์, ไฮดรอลิก', true],
    ['แค็ตตาล็อกบริการ', 'การถ่ายน้ำมัน, การตรวจระบบไอเสีย, การตั้งศูนย์ล้อ'],
    ['ใคร', 'สำหรับเขา, สำหรับเธอ, สำหรับคู่รัก', true],
    ['จุดหมายปลายทาง', 'ปารีส, เบอร์ลิน, ลอนดอน'],
    ['ชนิด', 'เสื้อยืด, แก้ว, กระเป๋า, ปากกา'],
    ['ชั้นเรียน', 'การเขียนเชิงสร้างสรรค์, โครงสร้างข้อมูล, พีชคณิตเชิงเส้น', true],
    ['ดอกไม้', 'กุหลาบ, เดซี่, ลิลลี่', true],
    ['ทำไม', 'วันเกิด, สำเร็จการศึกษา, วันครบรอบ', true],
    ['บริการ', 'ตัดผมชาย, ตัดผมหญิง, ตัดผมเด็ก'],
    ['แบรนด์', 'Windows, Xbox, Skype'],
    ['โปรแกรมปริญญา', 'การจัดการธุรกิจ, การบัญชี, การจัดการทรัพยากรบุคคล'],
    ['แผนก', 'เครื่องใช้ไฟฟ้า, โรงรถ, โรงภาพยนตร์ในบ้าน', true],
    ['พื้นที่ใกล้เคียง', 'Financial district, SOMA, North Beach'],
    ['ภาษา', 'อังกฤษ, สเปน, จีน', true],
    ['ยานพาหนะ', 'กะทัดรัด, SUV, ปรับเปลี่ยนได้', true],
    ['ราคา', 'ต่ำกว่า $10, $50-$100, สูงกว่า $1000', true],
    ['รายการโชว์', 'The Voyage, Knights, American Dancer'],
    ['รุ่น', 'Corolla, Prius, Yaris'],
    ['โรงแรมที่น่าสนใจ', 'Luxury Inn, Alpine Lodge, Lakeside Hotel'],
    ['วันหยุด', 'หมู่เกาะ, การขับรถท่องเที่ยว, การล่องเรือสำราญ', true],
    ['สไตล์', 'ชุกกะ, คาวบอย, คอมแบต, เชลซี'],
    ['สถานที่', 'อเมริกาเหนือ, ยุโรป, เอเชีย', true],
    ['สิ่งของ', 'แล็ปท็อป, ทีวี, คอนโซลเกม'],
    ['สิ่งอำนวยความสะดวก', 'WiFi, สระน้ำ, ศูนย์ฟิตเนส, ห้องครัวขนาดเล็ก'],
    ['สินค้า', 'เสื้อผ้า, หนังสือ, เกมกระดาน'],
    ['หลักสูตร', 'การขับขี่เชิงป้องกัน, การเป็นเจ้าของบ้าน 101'],
    ['หัวข้อ', 'รายได้, การเกษียณ, ภาษี', true],
    ['อะไร', 'ดอกไม้, ลูกกวาด, บัตรกำนัล', true],
    ['อัตรา', 'รายวัน, รายเดือน, รายปี', true],
    ['อัตรารายวัน', 'คนโสด, คู่รัก, กลุ่ม', true],
    ['โอกาส', 'สำเร็จการศึกษา, หายป่วย, มีลูกคนใหม่', true],
    ['ไฮไลต์', 'สิ่งที่ควรทาน, สิ่งที่ควรดู, สิ่งที่ต้องทำ', true],
  ]],
  ['Indonesian', [
    ['Acara', 'Kelulusan, Semoga sembuh, Kelahiran bayi', true],
    ['Acara', 'The Voyage, Knights, American Dancer'],
    ['Alat', 'Elektris, Pneumatik, Hidraulis', true],
    ['Apa', 'Bunga, Permen, Kartu hadiah', true],
    ['Bahasa', 'Inggris, Spanyol, Tionghoa', true],
    ['Barang', 'Pakaian, Buku, Permainan papan'],
    ['Bunga', 'Mawar, Aster, Lili', true],
    ['Departemen', 'Peralatan, Garasi, Bioskop rumah', true],
    ['Distrik sekolah', 'Jelajahi, Peringkat, Saran', true],
    ['Fasilitas', 'WiFi, Kolam renang, Pusat kebugaran, Dapur kecil'],
    ['Gaya', 'Chukka, Cowboy, Combat, Chelsea'],
    ['Harga', 'Di bawah $10, $50-$100, Di atas $1000', true],
    ['Hotel unggulan', 'Luxury Inn, Alpine Lodge, Lakeside Hotel'],
    ['Item', 'Laptop, TV, Konsol game'],
    ['Katalog layanan', 'Penggantian oli, Pemeriksaan asbut, Penyelarasan ban'],
    ['Kelas', 'Penulisan kreatif, Struktur data, Aljabar linear', true],
    ['Kelompok usia', '40 ke bawah, 41 hingga 50, 51 hingga 60', true],
    ['Kendaraan', 'Kompak, SUV, Konvertibel', true],
    ['Kursus', 'Berkendara defensif, Pengantar kepemilikan rumah'],
    ['Layanan', 'Model rambut pria, Model rambut wanita, Model rambut anak-anak'],
    ['Liburan', 'Kepulauan, Perjalanan darat, Kapal pesiar', true],
    ['Lingkungan', 'Distrik keuangan, SOMA, Pantai Utara'],
    ['Lokasi', 'Amerika Utara, Eropa, Asia', true],
    ['Mengapa', 'Ulang Tahun, Kelulusan, Hari Jadi', true],
    ['Merek', 'Windows, Xbox, Skype'],
    ['Model', 'Corolla, Prius, Yaris'],
    ['Penawaran', 'Barang cuci gudang, Beli satu bonus satu, Diskon pelajar', true],
    ['Peringkat', 'Terlaris, Termurah, Paling banyak diulas', true],
    ['Perlindungan asuransi', 'Tanggung jawab pihak ketiga, Tabrakan, Payung, Penyewaan mobil'],
    ['Program gelar', 'Administrasi bisnis, Akuntansi, Manajemen SDM'],
    ['Siapa', 'Untuknya, Baginya, Untuk pasangan', true],
    ['Sorotan', 'Apa yang harus dimakan, Apa yang harus dilihat, Apa yang harus dilakukan', true],
    ['Tarif harian', 'Lajang, Menikah, Kelompok', true],
    ['Tarif', 'Harian, Bulanan, Tahunan', true],
    ['Terlaris', 'Penawaran hari ini, Buket ulang tahun, Buket kebun', true],
    ['Tingkat', 'Diamond, Premium, Premium Plus', true],
    ['Tipe', 'Kaus, Mug, Tas, Pena'],
    ['Topik', 'Pendapatan, Pensiun, Pajak', true],
    ['Tujuan', 'Paris, Berlin, London'],
    ['Ukuran', 'Kecil, Sedang, Besar', true],
  ]],
  ['Tagalog', [
    ['Ano', 'Bulaklak, Candies, Gift card', true],
    ['Bakit', 'Birthday, Graduation, Anniversary', true],
    ['Catalog ng serbisyo', 'Pagpapalit ng langis, Smog check, Pag-align ng gulong'],
    ['Grado', 'Diamond, Premium, Premium Plus', true],
    ['Grupo ayon sa edad', '40 pababa, 41 hanggang 50, 51 hanggang 60', true],
    ['Mga Amenities', 'WiFi, Pool, Fitness center, Kitchenette'],
    ['Mga Bakasyon', 'Mga Isla, Mga Roadtrip, Mga Paglalayag', true],
    ['Mga Brand', 'Windows, Xbox, Skype'],
    ['Mga Bulaklak', 'Roses, Daisies, Lilies', true],
    ['Mga Deal', 'Mga item sa clearance, Buy one get one, Student discounts', true],
    ['Mga destinasyon', 'Paris, Berlin, London'],
    ['Mga distrito ng paaralan', 'Galugarin, Mga Ranggo, Mga Suhestiyon', true],
    ['Mga Estilo', 'Chukka, Cowboy, Combat, Chelsea'],
    ['Mga feature na hotel', 'Luxury Inn, Alpine Lodge, Lakeside Hotel'],
    ['Mga highlight', 'Ano ang makakain, Ano ang makikita, Ano ang gagawin', true],
    ['Mga item', 'Mga laptop, TV, Game console'],
    ['Mga Kagamitan', 'Damit, Mga Aklat, Board games'],
    ['Mga kagawaran', 'Appliances, Garage, Home theater', true],
    ['Mga Kapitbahay', 'Financial district, SOMA, North Beach'],
    ['Mga Klase', 'Malikhaing pagsusulat, mga istraktura ng data, Linear algebra', true],
    ['Mga Kurso', 'Defensive na pagmamaneho, Pagmamay-ari ng Bahay 101'],
    ['Mga Lokasyon', 'North America, Europe, Asia', true],
    ['Mga Modelo', 'Corolla, Prius, Yaris'],
    ['Mga Okasyon', 'Graduations, Magpagaling ka, Bagong baby', true],
    ['Mga paksa', 'Income, Pagreretiro, Buwis', true],
    ['Mga Palabas', 'The Voyage, Knights, American Dancer'],
    ['Mga pang-araw-araw na rate', 'Mga Single, Couple, Grupo', true],
    ['Mga presyo', 'Sa ilalim ng $10, $50-$100, Higit sa $1000', true],
    ['Mga programa sa degree', 'Pangangasiwa ng negosyo, Accounting, pamamahala ng HR'],
    ['Mga rate', 'Araw-araw, Buwan-buwan, Taunang', true],
    ['Mga rating', 'Pinakamabenta, Pinakamura, Pinaka-review', true],
    ['Mga sasakyan', 'Compact, SUV, Mapapalitan', true],
    ['Mga Serbisyo', 'Gupit ng lalaki, Gupit ng Babae, Gupit ng Bata'],
    ['Mga sukat', 'Maliit, Katamtaman, Malaki', true],
    ['Mga Tool', 'Electric, Pneumatic, Hydraulic', true],
    ['Mga Uri', 'Mga T-Shirt, Mug, Bag, Panulat'],
    ['Mga Wika', 'English, Spanish, Chinese', true],
    ['Pinaka mabenta', 'Deal ng araw, Birthday bouquet, Garden bouquet', true],
    ['Saklaw ng insurance', 'Pananagutan ng third party, Pagbangga, Payong, Pag-arkila ng kotse'],
    ['Sino', 'Para sa kanya, Para sa kanya, Para sa mga mag-asawa', true],
  ]],
  ['Vietnamese', [
    ['Các lớp học', 'Viết sáng tạo, Cấu trúc dữ liệu, Đại số tuyến tính', true],
    ['Cái gì', 'Hoa, Kẹo, Thẻ quà tặng', true],
    ['Chủ đề', 'Thu nhập, Nghỉ hưu, Thuế', true],
    ['Chương trình bằng cấp', 'Quản trị kinh doanh, Kế toán, Quản lý nhân sự'],
    ['Chương trình', 'Chuyến du hành, Hiệp sĩ, Vũ công Mỹ'],
    ['Công cụ', 'Điện, khí nén, thủy lực', true],
    ['Cước phí hàng ngày', 'Đơn, Cặp đôi, Nhóm', true],
    ['Danh mục dịch vụ', 'Thay dầu, kiểm tra khói bụi, căn chỉnh lốp'],
    ['Dịch vụ', 'Cắt tóc nam, Cắt tóc nữ, Cắt tóc trẻ em'],
    ['Điểm đến', 'Paris, Berlin, London'],
    ['Điểm', 'Kim cương, Premium, Premium Plus', true],
    ['Dịp', 'Lễ tốt nghiệp, Khỏe mạnh, Em bé mới', true],
    ['Đối tượng', 'Dành cho anh ấy, Dành cho cô ấy, Dành cho các cặp đôi', true],
    ['Giá cả', 'Dưới $10, $50-$100, trên $1000', true],
    ['Giá', 'Hàng ngày, hàng tháng, hàng năm', true],
    ['Giao dịch', 'Hàng thanh lý, Mua một tặng một, Giảm giá cho học viên', true],
    ['Hàng hoá', 'Quần áo, Sách, Trò chơi trên bảng'],
    ['Hoa', 'Hoa hồng, hoa cúc, hoa huệ', true],
    ['Học khu', 'Khám phá, Xếp hạng, Đề xuất', true],
    ['Khóa học', 'Lái xe phòng thủ, Quyền sở hữu nhà 101'],
    ['Kích thước', 'Nhỏ, Trung bình, Lớn', true],
    ['Kiểu', 'Chukka, Cao Bồi, Trận Chiến, Chelsea'],
    ['Kỳ nghỉ', 'Quần đảo, Chuyến đi đường, Du lịch trên biển', true],
    ['Loại', 'Áo thun, cốc, túi xách, bút'],
    ['Mặt hàng', 'Máy tính xách tay, TV, bảng điều khiển trò chơi'],
    ['Mô hình', 'Corolla, Prius, Yaris'],
    ['Ngôn ngữ', 'Tiếng Anh, Tiếng Tây Ban Nha, Tiếng Trung', true],
    ['Người bán Tốt nhất', 'Thỏa thuận trong ngày, Bó hoa sinh nhật, Bó hoa sân vườn', true],
    ['Nhóm vai trò', '40 và dưới, 41 đến 50, 51 đến 60', true],
    ['Phạm vi bảo hiểm', 'Trách nhiệm pháp lý của bên thứ ba, Va chạm, Ô dù, Cho thuê ô tô'],
    ['Phòng ban', 'Thiết bị gia dụng, Gara, Rạp hát tại nhà', true],
    ['Tại sao', 'Sinh nhật, Tốt nghiệp, Kỷ niệm', true],
    ['Thương hiệu', 'Windows, Xbox, Skype'],
    ['Tiện nghi', 'WiFi, Hồ bơi, Trung tâm thể hình, Bếp nhỏ'],
    ['Tin nổi bật', 'Ăn gì, xem gì, làm gì', true],
    ['Trợ giúp nổi bật', 'Nhà trọ sang trọng, Nhà nghỉ Alpine, Khách sạn gần hồ'],
    ['Vị trí', 'Bắc Mỹ, Châu Âu, Châu Á', true],
    ['Vùng lân cận', 'Khu tài chính, SOMA, Bãi biển phía Bắc'],
    ['Xe', 'Nhỏ gọn, SUV, Có thể chuyển đổi', true],
    ['Xếp hạng', 'Bán chạy nhất, Rẻ nhất, Được đánh giá nhiều nhất', true],
  ]],
];

/**
 * Script to compare model in doc
 * model = requirejs('@bingads-webui-campaign-legacy/adextension-structuredsnippet/model/model')
 * uimodel = {};_.each(model.default, item => uimodel[item[0]] = _.map(item[1], i => i[0]))
 * docModel = {}; _.each(docStr.split(';'), (ss) => {items = ss.split(','); key = items[0]; items.shift(); docModel[key] = _.map(items, item=>item.trim())})
 * ret = {}; _.each(uimodel, (vals, key) => {ui2doc = _.difference(vals, docModel[key]); doc2ui = _.difference(docModel[key], vals); if (_.size(ui2doc.concat(doc2ui)) > 0) {ret[key]={ui2doc, doc2ui}}})
 */

const oldHeaderPredicate = ([, , isNewHeader]) => !isNewHeader;

// const filterLangHeaders = (withNewHeaders, lang, langHeaders) => [lang, [withNewHeaders ? langHeaders : filter(langHeaders, langHeaderPredicate)]];

const filterHeaders = (withNewHeaders = false) =>
  headers.map(([lang, langHeaders]) => [lang, withNewHeaders ? langHeaders : filter(langHeaders, oldHeaderPredicate)]);

const buildHeadersMap = (hheaders) => hheaders
  .reduce((map, [lang, langHeaders]) => {
    map[lang] = langHeaders;
    return map;
  }, {});

export const OldHeaders = filterHeaders(false);
export const OldHeadersMap = buildHeadersMap(OldHeaders);
export const Headers = filterHeaders(true);
export const HeadersMap = buildHeadersMap(Headers);
